$(function(){

  function _spCertUrl(d){
    if (!d) return '#';
    if (d.lab_url) return d.lab_url;
    var lab = (d.lab || '').toUpperCase();
    var num = d.cert_num || d.certificate_no || '';
    if (!num) return '#';
    if (lab === 'GIA')  return 'https://www.gia.edu/report-check?reportno=' + encodeURIComponent(num);
    if (lab === 'IGI')  return 'https://www.igi.org/verify-your-report/?r=' + encodeURIComponent(num);
    if (lab === 'GCAL') return 'https://www.gcalusa.com/certificate-search.html?certificate_id=' + encodeURIComponent(num);
    return '#';
  }


  var _diamonmd = '';

  //Check for sku

  function getUrlVars()

  {

      var vars = [], hash;

      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

      for(var i = 0; i < hashes.length; i++)

      {

          hash = hashes[i].split('=');

          vars.push(hash[0]);

          vars[hash[0]] = hash[1];

      }

      return vars;

  }



  function doloader(type){

    if(type=='show'){

      // Early-render already painted the real stone - don't flash the
      // skeleton over it (the rebuild is near-instant off the prefetched data).
      if (window.__spEarlyRendered) return;

      $('#skel').show();

    }else{

      $('#skel').hide();

    }

  }



var _sku = getUrlVars()['sku'];

if(_sku){

     $('#noproduct').hide();

    

    //check main product type

    var _selectedRing = $.cookie("_ring");

    if(_selectedRing){

      _ringData = $.parseJSON(_selectedRing);

      var _productType = _ringData.productType

      _productType = (_productType=='Rings') ? 'Ring' : _productType;

      var _btnTxt = 'Add to '+_productType;

    }else{

      var _btnTxt = 'Add to Ring';

      var _productType = 'Ring';

    }





  

    //Get diamond data

    async function getData(){

    doloader('show');

    var user = 'fooPalawat';

    var pass = 'barPalawat';

    var authorizationBasic = window.btoa(user + ':' + pass);

    const config = {

        headers: { 'content-type': 'multipart/form-data' ,"Authorization": "Basic " + authorizationBasic }

    }

    // Pre-stash fast path - collection-page hover pre-fetched the diamond

    // record into sessionStorage under sd_pdp_diamond_<sku>. If fresh (<60s)

    // use it directly and skip the axios call entirely. Saves 200-400ms.

    var __cachedResp = (function(){

      try {

        var raw = sessionStorage.getItem('sd_pdp_diamond_' + _sku);

        if (!raw) return null;

        var entry = JSON.parse(raw);

        // partial entries are the catalog's click-time card stash - enough for
        // the head script's first paint, but missing cert/price detail; this
        // full render must fall through to the real fetch.
        if (!entry || entry.partial || (Date.now() - (entry.ts||0)) > 60000) return null;

        return entry.response;

      } catch(_) { return null; }

    })();

    // Tier 2 fast path - the section's inline head-start fetch (fires at
    // document parse, ~10s before this script runs on slow connections).
    // Only consumed when its URL matches exactly what we'd request here.

    var __prefetched = (function(){

      try {

        var pf = window.__spDiamondPrefetch;

        if (pf && pf.p && pf.url === `${theme.settings.apiUrl}/diamond/${_sku}?type=${_productType}`) return pf.p;

      } catch(_) {}

      return null;

    })();

    var __dataPromise = __cachedResp

      ? Promise.resolve({ data: __cachedResp })

      : __prefetched

        ? __prefetched.then(function(j){ return { data: j }; })

        : axios.get(`${theme.settings.apiUrl}/diamond/${_sku}?type=${_productType}` , config);

    await __dataPromise.then(response=>{

        var diamondData = response.data.Diamond;

        if(diamondData){

            var value = diamondData;

            var _diamondUpdate = $('#diamondupdatetab').html();

            // 2026-05-11: vendor-aware "Ships Loose By" date.

            //   Stienhardt (in-house, ready to ship): next business day

            //   Nivoda     (sourced via SFTP feed):   5 full business days

            // Weekends skipped; US federal holidays not handled here (TODO).

            // Loose ship-out = Stienhardt 1 biz day, Nivoda = shop.custom.nivoda_transit_days.
            var _spNvTransit = (window.SP_FF && window.SP_FF.NIVODA_TRANSIT) || 7;
            var _spIsNivoda = !!(value && String(value.api_vendor || '').toLowerCase() === 'nivoda');
            window.__spDiamondIsNivoda = _spIsNivoda; // (2026-09-24) read by the platinum re-date after render
            var _bizDays = _spIsNivoda ? _spNvTransit : 1;

            var shipByDate = Date.today();

            while (_bizDays > 0) {

              shipByDate.addDays(1);

              if (!shipByDate.is().saturday() && !shipByDate.is().sunday()) _bizDays--;

            }

            // 2026-09-07 r2: "Ships in a ring by" = engagement-ring lead, PLUS Nivoda
            // transit when the stone has to be shipped in first (it cannot be set
            // before it arrives). Both numbers come from shop settings via SP_FF, so
            // this no longer needs a hand edit when the lead time changes.
            var shipInDate = Date.today();
            var _ringBiz = ((window.SP_FF && window.SP_FF.MTO_RING) || 10)
                         + (_spIsNivoda ? _spNvTransit : 0);
            while (_ringBiz > 0) {
              shipInDate.addDays(1);
              if (!shipInDate.is().saturday() && !shipInDate.is().sunday()) _ringBiz--;
            }

            _diamonmd = diamondData;

            var diamondImages = response.data.diamondImages;

            var dims = value.measurement;

            var parts = [];



            if (/[x\*]/i.test(dims)) {

                parts = dims.split(/x|\*/i).map(p => p.trim());

            } else {

                parts = [dims.trim()]; // or ["*","*"] as fallback

            }

            // ["6.90", "6.92", "4.19"]



            // if you want as numbers

            let numbers = parts.map(Number);

            // [6.9, 6.92, 4.19]



            // access individually

            let length = numbers[0];

            let width  = numbers[1];



            var _diamondFor = ( _diamonmd.final_price ) ? 'Earring' : '';

            if(_diamondFor != 'Earring'){

              var productHtml = '<div class="grid__item product-single__diamond-group medium-up--two-thirds" data-product-single-media-group="">'

                + '<div class="diamond-image-wrapper" style="display:none;">'

                    + '<div class="diamond-image">'

                        + '<div class="diamondimg diamond-image-grid">'

                            + '<div class="image-wrapper">';

                                if( value.cover_pic.indexOf("http") == 0 ){

                                    productHtml +='<img src="'+value.cover_pic+'" alt="'+value.title+'">';

                                }else{

                                    productHtml +='<img src="'+theme.settings.assetUrl+value.cover_pic+'" alt="'+value.title+'">';

                                }

                            productHtml +='</div>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-iframe">'

                        + '<div class="diamond-image-grid">'

                            + '<iframe width="600px" height="600px" data-uw-rm-iframe="un"></iframe>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-certificate">'

                        + '<div class="diamond-image-grid">'

                            + '<div class="image-wrapper">'

                                + '<img class="thubnil-img lazyloaded" alt="IGI Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">'

                            + '</div>'

                        + '</div>'

                    + '</div>'

                + '</div>'

                + '<div class="diamond-thumbnil-wrapper" style="display:none;">'

                    + '<div class="diamond-thumbnil diamond-image active" data-type="diamond-image">';

                        if( value.cover_pic.indexOf("http") == 0 ){

                            productHtml +='<img src="'+value.cover_pic+'" alt="'+value.title+'">';

                        }else{

                            productHtml +='<img src="'+theme.settings.assetUrl+value.cover_pic+'" alt="'+value.title+'">';

                        }

                    productHtml +='</div>';

                    if( value.workshop_preview_url ){

                    productHtml +='<div class="diamond-thumbnil diamond-360" data-frame="'+value.workshop_preview_url+'" data-type="diamond-iframe">'

                        + '<img alt="Diamond Video" class="thubnil-img ls-is-cached lazyloaded"  src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/video_play.png?v=1716214635" >'

                    + '</div>';

                    }

                  if( value.raw_diamond ){

                    productHtml +='<div class="diamond-thumbnil diamond-size-preivew" data-carat="'+value.carat+'" data-type="diamond-fingure-view">'

                        + '<img alt="Loose Diamond" class="thubnil-img ls-is-cached lazyloaded" src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/loose-diamond-hand.webp?v=1716214787">'

                        + '<div class="diamond-on-hand">'

                            + '<span class="hand_diamond_img round oval" style="background-size: 41.85%;background-image: url('+theme.settings.assetUrl+value.raw_diamond+');"></span>'

                        + '</div>'

                    + '</div>';

                  }

                    productHtml +='<div class="diamond-thumbnil diamond-certificate" data-type="diamond-certificate">'

                        + '<a href="'+_spCertUrl(value)+'" target="_blank" rel="null noopener" aria-describedby="a11y-new-window-message" data-uw-original-href="'+_spCertUrl(value)+'">';

                        if(value.lab=='GIA'){

                            productHtml +='<img alt="GIA Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/GIA-Logo.jpg?v=1744102867">';

                        }else{

                          productHtml +='<img alt="IGI Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">'

                        }

                        productHtml +='</a>'

                    + '</div>'

                + '</div>'

                + '<!-- One single markup -->'

                + '<div class="product-media-gallery swiper">'

                    + '<div class="swiper-wrapper">';

                        // <!-- Images -->

                        if( value.cover_pic.indexOf("http") == 0 ){

                            productHtml +='<div class="swiper-slide"><img src="'+value.cover_pic+'" alt="'+value.title+'"></div>';

                        }else{

                            productHtml +='<div class="swiper-slide"><img src="'+theme.settings.assetUrl+value.cover_pic+'" alt="'+value.title+'"></div>';

                        }

                        if( value.workshop_preview_url ){

                            // Tag the slide with a vendor class so CSS can apply per-viewer fixes.

                            // gem360.in renders a fixed 1090px desktop layout (canvas in left half) - needs scale-down.

                            // loupe360.com is responsive - leave alone.

                            var _vurl = value.workshop_preview_url || '';

                            var _vendorCls = _vurl.indexOf('gem360.in') !== -1 ? 'is-gem360' :

                                             _vurl.indexOf('loupe360.com') !== -1 ? 'is-loupe360' : '';

                            // Facade: the gem360 viewer's inner page downloads its full spin
                            // frame set (~7 MB/stone) the moment its iframe gets a src, so the
                            // slide ships as a poster + 360 badge and the real viewer is
                            // injected only when the shopper taps it (see .sp-360-facade
                            // handler below). still.jpg is the same image the viewer shows
                            // before interaction, so the facade is visually identical.

                            var _poster = '';

                            var _vm = _vurl.match(/[?&]d=([^&#]+)/);

                            if (_vurl.indexOf('gem360.in') !== -1 && _vm) {

                                _poster = 'https://view.gem360.in/imaged/' + _vm[1] + '/still.jpg';

                            } else if (value.cover_pic) {

                                // loupe360 (Nivoda) and other vendors expose no still
                                // endpoint - reuse the stone's cover photo (same image as
                                // the first slide, so it's already in the browser cache).

                                _poster = value.cover_pic.indexOf('http') == 0 ? value.cover_pic : theme.settings.assetUrl + value.cover_pic;

                            }

                            productHtml +='<div class="swiper-slide swiper-no-swiping video-slide '+_vendorCls+'">'

                                + '<button type="button" class="sp-360-facade" data-viewer-src="'+_vurl+'" aria-label="Load interactive 360 view">'

                                +   (_poster ? '<img src="'+_poster+'" alt="'+value.title+' 360 preview" loading="lazy" decoding="async">' : '')

                                +   '<span class="sp-360-facade__badge">360&deg; view</span>'

                                + '</button>'

                            + '</div>';

                        }



                        if (value.lab == 'GIA') {

                            productHtml += `

                                <div class="swiper-slide">

                                    <div class="cert-card">

                                        <img class="cert-image" alt="GIA Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/GIA-Logo.jpg?v=1744102867">

                                        <h4 class="cert-title">GIA DIAMOND</h4>

                                        <a href="${_spCertUrl(value)}" target="_blank" class="cert-link">View Certificate</a>

                                    </div>

                                </div>`;

                        } else {

                            productHtml += `

                                <div class="swiper-slide">

                                    <div class="cert-card">

                                        <img class="cert-image" alt="IGI Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">

                                        <h4 class="cert-title">LAB DIAMOND</h4>

                                        <a href="${_spCertUrl(value)}" target="_blank" class="cert-link">View Certificate</a>

                                    </div>

                                </div>`;

                        }

                        if (value.shape === "Asscher") {

                            // do something for Asscher

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 130" height="130" width="130">

                                    <g id="Asscher-Plot-Diagram">

                                        <path stroke="black" d="M29.4059 2H102.045M29.4059 2L1.80005 29.2308M29.4059 2L34.6995 11.8462M102.045 2L127.8 27.6923M102.045 2L96.6962 11.8462M127.8 27.6923V102.308M127.8 27.6923L117.776 33.7388M127.8 102.308L102.045 128M127.8 102.308L117.776 96.2612M102.045 128H29.4059M102.045 128L96.463 118M29.4059 128L2.26272 100.923M29.4059 128L34.8169 118M2.26272 100.923L1.80005 29.2308M2.26272 100.923L11.2076 95.9322M1.80005 29.2308L11.2076 34.1316M44.2113 29.5385H87.0852M44.2113 29.5385L29.5601 43.6923M44.2113 29.5385L39.4554 20.6923M87.0852 29.5385L101.274 43.6923M87.0852 29.5385L91.8907 20.6923M101.274 43.6923V86.3077M101.274 43.6923L109.525 38.7156M101.274 86.3077L86.931 100.923M101.274 86.3077L109.525 91.2844M86.931 100.923H44.0571M86.931 100.923L91.697 109.462M44.0571 100.923L29.5601 85.6923M44.0571 100.923L39.437 109.462M29.5601 85.6923V43.6923M29.5601 85.6923L20.3839 90.8123M29.5601 43.6923L20.3839 38.912M11.2076 34.1316L34.6995 11.8462M11.2076 34.1316L20.3839 38.912M11.2076 34.1316V95.9322M34.6995 11.8462L39.4554 20.6923M34.6995 11.8462H96.6962M96.6962 11.8462L117.776 33.7388M96.6962 11.8462L91.8907 20.6923M117.776 33.7388L109.525 38.7156M117.776 33.7388V96.2612M117.776 96.2612L96.463 118M117.776 96.2612L109.525 91.2844M96.463 118L91.697 109.462M96.463 118H34.8169M34.8169 118L11.2076 95.9322M34.8169 118L39.437 109.462M11.2076 95.9322L20.3839 90.8123M20.3839 38.912L39.4554 20.6923M20.3839 38.912V90.8123M39.4554 20.6923H91.8907M91.8907 20.6923L109.525 38.7156M109.525 38.7156V91.2844M109.525 91.2844L91.697 109.462M91.697 109.462H39.437M39.437 109.462L20.3839 90.8123" id="Vector-Asscher-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M50.181 1V129M50.181 129H41.8M50.181 129H57.8M41.8 1H57.8" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="81.4756" x="35.0383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="87.9349" x="38.0533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 63.1429L129 63.1429M129 63.1429V71M129 63.1429V56M1 71L1 56" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="56.9756" x="56.2383" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="63.681" x="58.8602" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 141" height="141" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M134.526 29.9234L149 42.8889M134.526 29.9234L126.565 25.0131M134.526 29.9234H115.347M149 42.8889V46.6705M149 42.8889H120.594M149 46.6705L128.917 78.5441M149 46.6705H120.594M128.917 78.5441L101.958 97.272M128.917 78.5441H109.919M75 116L101.958 97.272M75 116L48.2225 97.272M75 116L57.4499 97.272M75 116L93.6357 97.272M21.445 78.5441L1 46.6705M21.445 78.5441L48.2225 97.272M21.445 78.5441H40.6235M1 46.6705V42.8889M1 46.6705H29.044M1 42.8889L17.1027 29.9234M1 42.8889H29.044M17.1027 29.9234L24.5029 25.0131M17.1027 29.9234H35.0147M101.958 97.272H93.6357M48.2225 97.272H57.4499M57.4499 97.272H93.6357M57.4499 97.272L40.6235 78.5441M93.6357 97.272L109.919 78.5441M109.919 78.5441L120.594 46.6705M109.919 78.5441H40.6235M120.594 46.6705H29.044M120.594 46.6705V42.8889M29.044 46.6705L40.6235 78.5441M29.044 46.6705V42.8889M120.594 42.8889H29.044M120.594 42.8889L115.347 29.9234M29.044 42.8889L35.0147 29.9234M126.565 25.0131L121.68 22H108.291M126.565 25.0131H110.824M24.5029 25.0131L29.044 22H42.0709M24.5029 25.0131H38.9951M42.0709 22L38.9951 25.0131M42.0709 22H108.291M38.9951 25.0131H110.824M38.9951 25.0131L35.0147 29.9234M35.0147 29.9234H115.347M108.291 22L110.824 25.0131M110.824 25.0131L115.347 29.9234" id="Asscher-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M29 11.7619L122 11.7619M122 11.7619V17M122 11.7619V7M29 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M132.762 22V116M132.762 116H127M132.762 116H138M127 22H138" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="99" x="112" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="104.818" x="114.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="134" x="55" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="139.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 120V130M75.2857 130H69M75.2857 130H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 110.5C77.4853 110.5 79.5 112.515 79.5 115C79.5 117.485 77.4853 119.5 75 119.5C72.5147 119.5 70.5 117.485 70.5 115C70.5 112.515 72.5147 110.5 75 110.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Antique Cuts") {

                            // do something for Antique Cuts

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 130" height="130" width="130">

                                    <g id="Antique-Cuts-Plot-Diagram">

                                        <path stroke="black" d="M65.375 2L101.375 17.7032M65.375 2C85.016 2 98.497 2 107.75 3.92622M65.375 2L29.375 17.7032M65.375 2C45.4988 2 31.8563 2 22.4925 3.92622M128 64.4392C128 45.1194 128 31.7774 126.145 22.5638M128 64.4392L112.625 29.6676M128 64.4392C128 84.0282 128 97.58 126.145 106.955M128 64.4392L112.625 101.08M64.625 128L29.375 112.671M64.625 128L101.375 112.671M64.625 128C84.6735 128 98.3797 128 107.75 125.988M64.625 128C45.1549 128 31.7381 128 22.4925 126.09M2 64.4392C2 45.1194 2.00001 31.7774 3.87741 22.5638M2 64.4392L18.125 29.6676M2 64.4392C2 84.1843 2 97.7956 3.87741 107.179M2 64.4392L18.125 101.08M101.375 17.7032L107.75 3.92622M101.375 17.7032L120.918 10.5994M101.375 17.7032L65.375 29.6676M101.375 17.7032L90.875 39.3887M107.75 3.92622C113.733 5.1717 117.948 7.22251 120.918 10.5994M29.375 17.7032L22.4925 3.92622M29.375 17.7032L9.16676 10.5994M29.375 17.7032L65.375 29.6676M29.375 17.7032L39.5 39.3887M22.4925 3.92622C16.4379 5.1717 12.1722 7.22251 9.16676 10.5994M9.16676 10.5994L18.125 29.6676M9.16676 10.5994C6.58565 13.4995 4.93413 17.3777 3.87741 22.5638M120.918 10.5994L112.625 29.6676M120.918 10.5994C123.469 13.4995 125.101 17.3777 126.145 22.5638M112.625 29.6676L126.145 22.5638M112.625 29.6676L90.875 39.3887M112.625 29.6676L101.375 64.4392M18.125 29.6676L3.87741 22.5638M18.125 29.6676L39.5 39.3887M18.125 29.6676L29.375 64.4392M29.375 112.671L9.16676 119.344M29.375 112.671L22.4925 126.09M29.375 112.671L39.5 90.6113M29.375 112.671L65.375 101.08M9.16676 119.344C12.1722 122.769 16.4379 124.839 22.4925 126.09M9.16676 119.344L18.125 101.08M9.16676 119.344C6.58565 116.402 4.93413 112.46 3.87741 107.179M101.375 112.671L120.747 119.344M101.375 112.671L107.75 125.988M101.375 112.671L90.875 90.6113M101.375 112.671L65.375 101.08M120.747 119.344C117.787 122.677 113.619 124.727 107.75 125.988M120.747 119.344L112.625 101.08M120.747 119.344C123.396 116.36 125.077 112.349 126.145 106.955M112.625 101.08L126.145 106.955M112.625 101.08L90.875 90.6113M112.625 101.08L101.375 64.4392M39.5 90.6113L18.125 101.08M39.5 90.6113L65.375 101.08M39.5 90.6113L29.375 64.4392M18.125 101.08L3.87741 107.179M18.125 101.08L29.375 64.4392M90.875 90.6113L65.375 101.08M90.875 90.6113L101.375 64.4392M65.375 29.6676L90.875 39.3887M65.375 29.6676L39.5 39.3887M90.875 39.3887L101.375 64.4392M39.5 39.3887L29.375 64.4392" id="Vector-Antique-Cuts-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M34.381 1V129M34.381 129H26M34.381 129H42M26 1H42" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="19.2383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.935" x="22.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 65.1429L129 65.1429M129 65.1429V73M129 65.1429V58M1 73L1 58" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="58.9756" x="46.2383" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="65.6811" x="48.8602" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 187" height="187" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 62.5417V67.506M149 62.5417H132.967M149 62.5417L117.756 35.5139M149 67.506L132.967 90.1536M149 67.506H132.967M1 67.506V62.5417M1 67.506H18.0611M1 67.506L18.0611 91.0211M1 62.5417H18.0611M1 62.5417L30.6 35.5139M75 67.506H92.6778M75 67.506V88.1905M75 67.506H57.7333M75 161H71.9167M75 161H78.9056M75 161V88.1905M71.9167 161H68.8333L18.0611 91.0211M71.9167 161L43.2626 88.1905M35.1222 67.506H57.7333M35.1222 67.506L43.2626 88.1905M35.1222 67.506H18.0611M78.9056 161H82.8111L132.967 90.1536M78.9056 161L108.52 88.1905M116.933 67.506H132.967M116.933 67.506L108.52 88.1905M116.933 67.506H92.6778M132.967 90.1536V67.506M132.967 67.506L108.52 88.1905M108.52 88.1905L92.6778 67.506M92.6778 67.506L75 88.1905M75 88.1905L57.7333 67.506M57.7333 67.506L43.2626 88.1905M43.2626 88.1905L18.0611 67.506M18.0611 67.506V91.0211M18.0611 62.5417L30.6 35.5139M18.0611 62.5417L55.2667 22M18.0611 62.5417H35.1222M30.6 35.5139L38 28.7569M55.2667 22H45.4L38 28.7569M55.2667 22L75 62.5417M55.2667 22H75.4111M75 62.5417L95.5556 22M75 62.5417H116.933M75 62.5417H35.1222M95.5556 22H102.133L109.944 28.7569M95.5556 22L132.967 62.5417M95.5556 22H75.4111M132.967 62.5417L117.756 35.5139M132.967 62.5417H116.933M117.756 35.5139L109.944 28.7569M109.944 28.7569L116.933 62.5417M116.933 62.5417L75.4111 22M75.4111 22L35.1222 62.5417M35.1222 62.5417L38 28.7569" id="Antique-Cuts-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M45 11.7619L102 11.7619M102 11.7619V17M102 11.7619V7M45 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="56" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="59.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M129.762 22V161M129.762 161H124M129.762 161H135M124 22H135" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="136" x="109" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="141.818" x="111.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="180" x="56" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="185.818" x="58">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 166V176M75.2857 176H69M75.2857 176H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 156.5C77.4853 156.5 79.5 158.515 79.5 161C79.5 163.485 77.4853 165.5 75 165.5C72.5147 165.5 70.5 163.485 70.5 161C70.5 158.515 72.5147 156.5 75 156.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Cushion") {

                            // do something for Cushion

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 128" height="128" width="130">

                                    <g id="Container-Cushion-Plot-Diagram">

                                        <path stroke="black" d="M128 63.6172C128 40.4579 123.822 24.9431 114.194 15.1502M128 63.6172L112.825 35.6002M128 63.6172L112.825 93.3183M128 63.6172C128 87.5106 124.182 103.464 114.194 113.389M65.3066 1C42.1741 1 26.1737 4.97956 16.0458 15.1502M65.3066 1L35.7226 17.6877M65.3066 1L95.1971 17.6877M65.3066 1C88.3947 1 104.219 5.00396 114.194 15.1502M2 63.6172C2 87.5309 5.95597 103.464 16.0458 113.374M2 63.6172L18.0949 93.3183M2 63.6172L18.0949 35.6002M2 63.6172C2 40.4289 6.30888 24.9283 16.0458 15.1502M65.3066 127L35.7226 111.69M65.3066 127C41.6569 127 25.9164 123.069 16.0458 113.374M65.3066 127C88.8983 127 104.47 123.051 114.194 113.389M65.3066 127L95.1971 111.69M35.7226 111.69L16.0458 113.374M35.7226 111.69L65.3066 98.2175M35.7226 111.69L36.6423 93.3183M16.0458 113.374L18.0949 93.3183M18.0949 93.3183L32.3503 63.6172M18.0949 93.3183H36.6423M18.0949 35.6002L16.0458 15.1502M18.0949 35.6002L32.3503 63.6172M18.0949 35.6002H36.6423M16.0458 15.1502L35.7226 17.6877M35.7226 17.6877L65.3066 31.4666M35.7226 17.6877L36.6423 35.6002M95.1971 17.6877L114.194 15.1502M95.1971 17.6877L65.3066 31.4666M95.1971 17.6877L94.1241 35.6002M114.194 15.1502L112.825 35.6002M112.825 35.6002L98.2628 63.6172M112.825 35.6002H94.1241M112.825 93.3183L98.2628 63.6172M112.825 93.3183L112.865 93.9148M114.194 113.389L95.1971 111.69M114.194 113.389L112.865 93.9148M95.1971 111.69L65.3066 98.2175M95.1971 111.69L94.1241 93.3183M98.2628 63.6172L94.1241 93.3183M98.2628 63.6172L94.1241 35.6002M65.3066 31.4666L94.1241 35.6002M65.3066 31.4666L36.6423 35.6002M32.3503 63.6172L36.6423 35.6002M32.3503 63.6172L36.6423 93.3183M65.3066 98.2175L94.1241 93.3183M65.3066 98.2175L36.6423 93.3183M94.1241 93.3183L112.865 93.9148" id="Cushion-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M33.381 1V127M33.381 127H25M33.381 127H41M25 1H41" id="Handle-Length"></path>

                                            <g id="Container-Length-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="45" y="81.9756" x="18.0176" id="Length-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Length-Value">

                                                    <tspan y="88.4349" x="21.0326">Length: ${length}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 65.1429L129 65.1429M129 65.1429V73M129 65.1429V58M1 73L1 58" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="43" y="58.9756" x="43.0176" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="65.681" x="45.6395">Width: ${width}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 153 142" height="142" width="153">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 34.8876V38.5698M149 34.8876L140.391 29.2267M149 34.8876H125.371M149 38.5698H125.371M149 38.5698L133.758 60.2946M101.926 98.5891L116.579 84.781L133.758 60.2946M101.926 98.5891L74.6337 117M101.926 98.5891L125.371 62.688M74.6337 117L47.8911 98.5891M74.6337 117V105.217M47.8911 98.5891L32.6881 84.781L15.8972 60.2946M47.8911 98.5891L24.2624 62.688M1 38.5698V34.8876M1 38.5698H24.2624M1 38.5698L15.8972 60.2946M1 34.8876L9.12617 29.2267M1 34.8876H24.2624M74.6337 79.0736L97.5297 71.157M74.6337 79.0736L52.2871 71.157M74.6337 79.0736V105.217M140.391 29.2267L129.401 22H116.579M140.391 29.2267H122.074M140.391 29.2267L116.579 22M9.12617 29.2267L19.5 22H30.8564M9.12617 29.2267H27.7426M9.12617 29.2267L30.8564 22M122.074 29.2267L125.371 34.8876M122.074 29.2267H27.7426M122.074 29.2267L79.9455 22M125.371 34.8876H24.2624M125.371 34.8876V38.5698M125.371 38.5698L120.059 55.876M125.371 38.5698H24.2624M120.059 55.876L97.5297 71.157M120.059 55.876L125.371 62.688M97.5297 71.157L74.6337 105.217M52.2871 71.157L29.3911 55.876M52.2871 71.157L74.6337 105.217M29.3911 55.876L24.2624 38.5698M29.3911 55.876L24.2624 62.688M24.2624 38.5698V34.8876M24.2624 34.8876L27.7426 29.2267M27.7426 29.2267L68.7723 22M24.2624 62.688L74.6337 105.217M24.2624 62.688L15.8972 60.2946M74.6337 105.217L125.371 62.688M125.371 62.688L133.758 60.2946M116.579 22H79.9455M30.8564 22H68.7723M79.9455 22H68.7723" id="Cushion-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M19 11.7619L129 11.7619M129 11.7619V17M129 11.7619V7M19 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="57" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="60.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M135.762 21V117M135.762 117H130M135.762 117H141M130 21H141" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="87" x="115" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="92.8182" x="117.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="135" x="54.5" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="140.818" x="56.5">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M74.7857 121V131M74.7857 131H68.5M74.7857 131H80.5" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M74.5 111.5C76.9853 111.5 79 113.515 79 116C79 118.485 76.9853 120.5 74.5 120.5C72.0147 120.5 70 118.485 70 116C70 113.515 72.0147 111.5 74.5 111.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Long Cushion") {

                            // do something for Long Cushion

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 94 130" height="130" width="94">

                                    <g id="Long-Cushion-Plot-Diagram">

                                        <path stroke="black" d="M47.1655 2L58.4154 21.3783M47.1655 2L36.0809 21.3783M47.1655 2C40.3465 2 34.5519 2.85959 29.6287 4.42799M47.1655 2C53.8938 2 59.6156 2.86236 64.4809 4.42799M92 65L76.2004 43.3953M92 65L76.2004 86.5222M92 65C92 56.8189 91.805 48.1822 90.543 40.0144M92 65C92 73.2437 91.8157 81.9502 90.543 90.1732M47.1655 128L58.4154 108.622M47.1655 128L35.9981 108.622M47.1655 128C40.3098 128 34.4882 127.117 29.5459 125.509M47.1655 128C54.0102 128 59.8128 127.114 64.7315 125.509M2 65L18.2959 43.3953M2 65L18.2959 86.5222M2 65C2 56.6324 2.23016 48.0481 3.469 40.0144M2 65C2 73.4328 2.25973 82.0856 3.55422 90.1732M58.4154 21.3783L59.4908 40.0144M58.4154 21.3783L47.1655 32.3455M58.4154 21.3783L64.4809 4.42799M58.4154 21.3783L82.2186 17.1728M59.4908 40.0144L66.7702 65M59.4908 40.0144L76.2004 43.3953M59.4908 40.0144L47.1655 32.3455M66.7702 65L59.4908 89.161M66.7702 65L76.2004 86.5222M66.7702 65L76.2004 43.3953M59.4908 89.161L58.4154 108.622M59.4908 89.161L76.2004 86.5222M59.4908 89.161L47.1655 96.5M58.4154 108.622L82.4271 112.631M58.4154 108.622L47.1655 96.5M58.4154 108.622L64.7315 125.509M36.0809 21.3783L34.8401 40.0144M36.0809 21.3783L47.1655 32.3455M36.0809 21.3783L29.6287 4.42799M36.0809 21.3783L11.781 17.1728M34.8401 40.0144L27.7261 65M34.8401 40.0144L18.2959 43.3953M34.8401 40.0144L47.1655 32.3455M27.7261 65L35.0055 89.161M27.7261 65L18.2959 43.3953M27.7261 65L18.2959 86.5222M35.0055 89.161L35.9981 108.622M35.0055 89.161L18.2959 86.5222M35.0055 89.161L47.1655 96.5M35.9981 108.622L11.781 112.631M35.9981 108.622L47.1655 96.5M35.9981 108.622L29.5459 125.509M76.2004 43.3953L82.2186 17.1728M76.2004 43.3953L90.543 40.0144M76.2004 86.5222L82.4271 112.631M76.2004 86.5222L90.543 90.1732M18.2959 43.3953L11.781 17.1728M18.2959 43.3953L3.469 40.0144M18.2959 86.5222L11.781 112.631M18.2959 86.5222L3.55422 90.1732M82.2186 17.1728C86.784 23.5985 89.2358 31.5549 90.543 40.0144M82.2186 17.1728C78.1818 11.4911 72.4925 7.00607 64.4809 4.42799M11.781 17.1728C7.24504 23.5486 4.78656 31.4702 3.469 40.0144M11.781 17.1728C15.8415 11.4652 21.5668 6.99628 29.6287 4.42799M11.781 112.631C7.35067 106.336 4.89631 98.5583 3.55422 90.1732M11.781 112.631C15.8312 118.386 21.5329 122.901 29.5459 125.509M82.4271 112.631C86.8628 106.287 89.2578 98.4768 90.543 90.1732M82.4271 112.631C78.4213 118.359 72.7514 122.891 64.7315 125.509" id="Vector-Long-Cushion-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M37.381 1V129M37.381 129H29M37.381 129H45M29 1H45" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="76.4756" x="22.2383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="82.9349" x="25.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 64.1429L93 64.1429M93 64.1429V72M93 64.1429V57M1 72L1 57" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="57.9756" x="43.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="64.681" x="45.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 137" height="137" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M123.742 29.5965L106.615 22H95.0601M123.742 29.5965L149 43.6673M123.742 29.5965L141.994 43.6673M123.742 29.5965L95.0601 22M123.742 29.5965L123.483 43.6673M149 43.6673V49.451M149 43.6673H141.994M149 49.451H142.513M149 49.451L139.777 59.4646M125.386 75.0892H120.974M125.386 75.0892L111.676 87.6494M125.386 75.0892L139.777 59.4646M97.9655 100.21L84.0392 108.151M97.9655 100.21L111.676 87.6494M97.9655 100.21H95.8895M84.0392 108.151L75.1298 111M84.0392 108.151L95.8895 100.21M84.0392 108.151H80.2332M75.1298 111L66.9123 108.151M75.1298 111L77.3787 108.151M75.1298 111L72.0158 108.151M75.1298 111L69.3343 108.151M75.1298 111L80.2332 108.151M75.1298 111L75.1237 108.151M66.9123 108.151L53.159 100.21M66.9123 108.151L54.9755 100.21M66.9123 108.151H69.3343M53.159 100.21L39.6651 87.6494M53.159 100.21H54.9755M26.1712 75.0892H30.4097M26.1712 75.0892L39.6651 87.6494M26.1712 75.0892L10.8312 59.4646M1 49.451V43.6673M1 49.451H8.00643M1 49.451L10.8312 59.4646M1 43.6673L26.8632 29.5965M1 43.6673H8.00643M26.8632 29.5965L42.8656 22H54.9755M26.8632 29.5965V43.6673M26.8632 29.5965L54.9755 22M26.8632 29.5965L8.00643 43.6673M75 49.451H97.9655M75 49.451H52.3805M75 49.451L75.0211 59.4646M97.9655 49.451H123.483M97.9655 49.451L95.0601 59.4646M90.5266 75.0892H108.345M90.5266 75.0892H75.054M90.5266 75.0892L86.3314 87.6494M90.5266 75.0892L95.0601 59.4646M82.1362 100.21L77.3787 108.151M82.1362 100.21L86.3314 87.6494M82.1362 100.21H89.6616M82.1362 100.21H75.107M77.3787 108.151H75.1237M77.3787 108.151H80.2332M72.0158 108.151L68.0368 100.21M72.0158 108.151H69.3343M72.0158 108.151H75.1237M68.0368 100.21L63.9714 87.6494M68.0368 100.21H75.107M68.0368 100.21H59.9059M59.9059 75.0892H75.054M59.9059 75.0892H41.7411M59.9059 75.0892L63.9714 87.6494M59.9059 75.0892L55.3197 59.4646M52.3805 49.451H26.6902M52.3805 49.451L55.3197 59.4646M26.6902 49.451H8.00643M26.6902 49.451L32.5687 59.4646M41.7411 75.0892H30.4097M41.7411 75.0892L50.8235 87.6494M41.7411 75.0892L32.5687 59.4646M59.9059 100.21L69.3343 108.151M59.9059 100.21L50.8235 87.6494M59.9059 100.21H54.9755M123.483 49.451H142.513M123.483 49.451L117.571 59.4646M108.345 75.0892H120.974M108.345 75.0892L99.0035 87.6494M108.345 75.0892L117.571 59.4646M89.6616 100.21L80.2332 108.151M89.6616 100.21L99.0035 87.6494M89.6616 100.21H95.8895M142.513 49.451L134.1 59.4646M120.974 75.0892L108.432 87.6494M120.974 75.0892L134.1 59.4646M95.8895 100.21L108.432 87.6494M8.00643 49.451L16.7565 59.4646M30.4097 75.0892L42.6926 87.6494M30.4097 75.0892L16.7565 59.4646M54.9755 100.21L42.6926 87.6494M75.054 75.0892L75.0805 87.6494M75.054 75.0892L75.0211 59.4646M111.676 87.6494H108.432M108.432 87.6494H99.0035M99.0035 87.6494H86.3314M86.3314 87.6494H75.0805M75.0805 87.6494H63.9714M75.0805 87.6494L75.107 100.21M63.9714 87.6494H50.8235M50.8235 87.6494H42.6926M42.6926 87.6494H39.6651M139.777 59.4646H134.1M134.1 59.4646H117.571M117.571 59.4646H95.0601M95.0601 59.4646H75.0211M75.0211 59.4646H55.3197M55.3197 59.4646H32.5687M32.5687 59.4646H16.7565M16.7565 59.4646H10.8312M141.994 43.6673H123.483M123.483 43.6673L93.6406 29.5965M123.483 43.6673H97.9655M93.6406 29.5965L95.0601 22M93.6406 29.5965L97.9655 43.6673M93.6406 29.5965L75.0805 22M93.6406 29.5965L75 43.6673M95.0601 22H75.0805M97.9655 43.6673H75M75.0805 22L56.5324 29.5965M75.0805 22H54.9755M75 43.6673L56.5324 29.5965M75 43.6673H52.3805M56.5324 29.5965L52.3805 43.6673M56.5324 29.5965L26.8632 43.6673M56.5324 29.5965L54.9755 22M52.3805 43.6673H26.8632M26.8632 43.6673H8.00643M75.107 100.21L75.1237 108.151" id="Long-Cushion-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M42 11.7619L107 11.7619M107 11.7619V17M107 11.7619V7M42 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="57" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="60.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M128.762 22V111M128.762 111H123M128.762 111H134M123 22H134" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="92" x="108" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="97.8182" x="110.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="130" x="56" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="135.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 116V126M75.2857 126H69M75.2857 126H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 106.5C77.4853 106.5 79.5 108.515 79.5 111C79.5 113.485 77.4853 115.5 75 115.5C72.0147 115.5 70.5 113.485 70.5 111C70.5 108.515 72.0147 106.5 75 106.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Emerald") {

                            // do something for Emerald

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 101 130" height="130" width="101">

                                    <g id="Emerald-Plot-Diagram">

                                        <path stroke="black" d="M16.6502 2H84.3498M16.6502 2L2 16.6154M16.6502 2L20.814 7.53846M84.3498 2L99 16.6154M84.3498 2L80.3462 7.53846M99 16.6154V113.385M99 16.6154L93.6025 19.4335M99 113.385L84.3498 128M99 113.385L93.6025 110.667M84.3498 128H16.6502M84.3498 128L76.714 117.538M16.6502 128L2 113.385M16.6502 128L20.6209 122.769M2 113.385V16.6154M2 113.385L7.32107 110.628M2 16.6154L7.32107 19.4335M28.6789 18H72.7838M28.6789 18L18.0382 25.2308M28.6789 18L24.9777 13.0769M72.7838 18L82.4992 25.2308M72.7838 18L76.3426 13.0769M82.4992 25.2308V105.077M82.4992 25.2308L88.0509 22.3321M82.4992 105.077L72.7838 112.154M82.4992 105.077L88.0509 107.872M72.7838 112.154H28.6789M72.7838 112.154L76.714 117.538M28.6789 112.154L18.0382 105.077M28.6789 112.154L24.5915 117.538M18.0382 105.077V25.2308M18.0382 105.077L12.6421 107.872M18.0382 25.2308L12.6421 22.3321M93.6025 19.4335V110.667M93.6025 19.4335L88.0509 22.3321M93.6025 19.4335L80.3462 7.53846M93.6025 110.667L88.0509 107.872M93.6025 110.667L80.3462 122.769H20.6209M88.0509 22.3321V107.872M88.0509 22.3321L76.3426 13.0769M88.0509 107.872L76.714 117.538M76.3426 13.0769H24.9777M76.3426 13.0769L80.3462 7.53846M24.9777 13.0769L20.814 7.53846M24.9777 13.0769L12.6421 22.3321M80.3462 7.53846H20.814M20.814 7.53846L7.32107 19.4335M12.6421 22.3321V107.872M12.6421 22.3321L7.32107 19.4335M12.6421 107.872L7.32107 110.628M12.6421 107.872L24.5915 117.538M7.32107 19.4335V110.628M7.32107 110.628L20.6209 122.769M24.5915 117.538H76.714M24.5915 117.538L20.6209 122.769" id="Vector-Emerald-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M35.381 1V129M35.381 129H27M35.381 129H43M27 1H43" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="81.9756" x="20.0176" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="88.435" x="23.0326" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 65.1429L100 65.1429M100 65.1429V73M100 65.1429V58M1 73L1 58" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="58.9756" x="38.1357" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="65.6811" x="40.7577" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 118" height="118" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M23.6438 22H126.175M23.6438 22L12.5936 25.6176M23.6438 22L21.8323 25.6176M126.175 22L137.588 25.6176M126.175 22L127.443 25.6176M137.588 25.6176L143.565 31.0439M137.588 25.6176H127.443M143.565 31.0439L149 36.6512M143.565 31.0439H130.341M149 36.6512V40.6305M149 36.6512H133.059M149 40.6305L128.53 65.5917M149 40.6305H133.059M128.53 65.5917L109.69 81.3282M128.53 65.5917H120.922M109.69 81.3282L95.5606 92H54.9829L39.7662 81.3282M109.69 81.3282H39.7662M109.69 81.3282L120.922 65.5917M39.7662 81.3282L21.8323 65.5917M39.7662 81.3282L29.8029 65.5917M21.8323 65.5917L1 40.6305M21.8323 65.5917H29.8029M1 40.6305V36.6512M1 40.6305H17.3036M1 36.6512L6.07222 31.0439M1 36.6512H17.3036M6.07222 31.0439L12.5936 25.6176M6.07222 31.0439H19.6585M12.5936 25.6176H21.8323M127.443 25.6176L130.341 31.0439M127.443 25.6176H21.8323M130.341 31.0439L133.059 36.6512M130.341 31.0439H19.6585M133.059 36.6512V40.6305M133.059 36.6512H17.3036M133.059 40.6305H17.3036M133.059 40.6305L120.922 65.5917M21.8323 25.6176L19.6585 31.0439M19.6585 31.0439L17.3036 36.6512M17.3036 36.6512V40.6305M17.3036 40.6305L29.8029 65.5917M29.8029 65.5917H120.922" id="Emerald-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M23 11.7619L126 11.7619M126 11.7619V17M126 11.7619V7M23 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="57" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="60.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M132.762 21V92M132.762 92H127M132.762 92H138M127 21H138" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="76" x="111" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="81.8182" x="113.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="111" x="55" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="116.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 97V107M75.2857 107H69M75.2857 107H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 87.5C77.4853 87.5 79.5 89.5147 79.5 92C79.5 94.4853 77.4853 96.5 75 96.5C72.5147 96.5 70.5 94.4853 70.5 92C70.5 89.5147 72.5147 87.5 75 87.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Heart") {

                            // do something for Heart

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 129" height="129" width="130">

                                    <g id="Heart-Plot-Diagram">

                                        <path stroke="black" d="M65.03 21.2308L45.8752 19.9705M65.03 21.2308L84.0301 19.9705M65.03 21.2308C72.1462 11.6531 81.3884 5.59257 90.6247 3.23152M65.03 21.2308C58.3587 11.1708 49.2066 5.09997 39.9085 2.91915M65.03 21.2308L93.294 31.4663M65.03 21.2308L36.1402 31.4663M127.365 53.6712C129.277 43.9801 129.43 35.6982 128.25 28.7892M127.365 53.6712L101.459 68.4735M127.365 53.6712L111.822 35.2458M127.365 53.6712C125.321 64.0347 116.978 78.4576 102.983 93.9849M64.403 128L74.9231 96.8195M64.403 128L54.197 96.8195M64.403 128C72.1264 122.467 79.1967 116.806 85.5851 111.15M64.403 128C56.6861 122.302 49.8042 116.663 43.6934 111.15M2.85163 53.6712C0.696109 44.0527 0.520463 35.7516 1.81864 28.7892M2.85163 53.6712C5.30407 63.8696 12.6073 77.9752 26.6615 93.9849M2.85163 53.6712L28.2894 68.4735M2.85163 53.6712L17.4553 35.2458M74.9231 96.8195L79.1626 75.56M74.9231 96.8195L102.983 93.9849M74.9231 96.8195L85.5851 111.15M74.9231 96.8195L64.403 88.9456M79.1626 75.56L92.1949 54.773M79.1626 75.56L101.459 68.4735M79.1626 75.56L64.403 88.9456M92.1949 54.773L111.822 35.2458M92.1949 54.773L93.294 31.4663M92.1949 54.773L101.459 68.4735M111.822 35.2458L119.202 10.0179M111.822 35.2458L93.294 31.4663M111.822 35.2458L128.25 28.7892M119.202 10.0179L84.0301 19.9705M119.202 10.0179C111.838 2.68911 101.235 0.519145 90.6247 3.23152M119.202 10.0179C123.61 14.4059 126.858 20.6432 128.25 28.7892M54.197 96.8195L50.5856 75.56M54.197 96.8195L64.403 88.9456M54.197 96.8195L43.6934 111.15M54.197 96.8195L26.6615 93.9849M50.5856 75.56L36.9252 54.773M50.5856 75.56L64.403 88.9456M50.5856 75.56L28.2894 68.4735M36.9252 54.773L17.4553 35.2458M36.9252 54.773L36.1402 31.4663M36.9252 54.773L28.2894 68.4735M17.4553 35.2458L11.4753 10.0179M17.4553 35.2458L36.1402 31.4663M17.4553 35.2458L1.81864 28.7892M11.4753 10.0179L45.8752 19.9705M11.4753 10.0179C18.9703 2.89715 29.5303 0.484988 39.9085 2.91915M11.4753 10.0179C6.80335 14.4566 3.32232 20.7248 1.81864 28.7892M45.8752 19.9705L39.9085 2.91915M45.8752 19.9705L36.1402 31.4663M84.0301 19.9705L90.6247 3.23152M84.0301 19.9705L93.294 31.4663M101.459 68.4735L102.983 93.9849M102.983 93.9849C97.9148 99.6085 92.1051 105.377 85.5851 111.15M43.6934 111.15C37.1608 105.256 31.5095 99.5074 26.6615 93.9849M26.6615 93.9849L28.2894 68.4735" id="Vector-Heart-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M32.381 1V128M32.381 128H24M32.381 128H40M24 1H40" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="17.2383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="20.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 63.1429L129 63.1429M129 63.1429V71M129 63.1429V56M1 71L1 56" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="56.9756" x="49.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="63.681" x="51.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 151 126" height="126" width="151">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M135.595 29.6452L122.371 22H111.864M135.595 29.6452L149 44.0253M135.595 29.6452L111.864 22M135.595 29.6452L129.073 44.0253M135.595 29.6452L140.486 44.0253M149 44.0253V47.1198M149 44.0253H140.486M149 47.1198L106.43 90.6244M149 47.1198H140.486M106.43 90.6244L90.8507 101M106.43 90.6244L140.486 47.1198M106.43 90.6244L129.073 47.1198M90.8507 101L66.5667 86.4378M90.8507 101L81.9743 86.4378M90.8507 101L95.3794 88.4401M1 47.1198V44.0253M1 47.1198L66.5667 86.4378M1 47.1198H14.224M1 44.0253L15.1297 29.6452M1 44.0253H14.224M15.1297 29.6452L40.3097 22H54.0771M15.1297 29.6452L14.224 44.0253M15.1297 29.6452L31.7956 44.0253M14.224 44.0253H31.7956M31.7956 44.0253L63.8592 30.3733M31.7956 44.0253H77.8078M63.8592 30.3733L81.3403 22M63.8592 30.3733L77.8078 44.0253M63.8592 30.3733L54.0771 22M81.3403 22H111.864M81.3403 22L102.263 31.1014M81.3403 22H54.0771M77.8078 44.0253L102.263 31.1014M77.8078 44.0253H105.705M102.263 31.1014L111.864 22M102.263 31.1014L129.073 44.0253M102.263 31.1014L105.705 44.0253M129.073 44.0253H140.486M129.073 44.0253H105.705M140.486 47.1198H129.073M129.073 47.1198L95.3794 88.4401M129.073 47.1198H105.705M95.3794 88.4401L105.705 47.1198M95.3794 88.4401L77.8078 47.1198M105.705 47.1198H77.8078M77.8078 47.1198L81.9743 86.4378M77.8078 47.1198H54.4394M81.9743 86.4378L54.4394 47.1198M81.9743 86.4378L31.7956 47.1198M54.4394 47.1198H31.7956M31.7956 47.1198L66.5667 86.4378M31.7956 47.1198H14.224M66.5667 86.4378L14.224 47.1198" id="Heart-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M40 11.7619L122 11.7619M122 11.7619V17M122 11.7619V7M40 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="64" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="67.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M133.762 22V101M133.762 101H128M133.762 101H139M128 22H139" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="86" x="113" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="91.8182" x="115.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="119" x="72" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="124.818" x="73">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M91.2857 105V115M91.2857 115H85M91.2857 115H97" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M91 95.5C93.4853 95.5 95.5 97.5147 95.5 100C95.5 102.485 93.4853 104.5 91 104.5C88.5147 104.5 86.5 102.485 86.5 100C86.5 97.5147 88.5147 95.5 91 95.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Marquise") {

                            // do something for Marquise

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 72 130" height="130" width="72">

                                    <g id="Marquise-Plot-Diagram">

                                        <path stroke="black" d="M37.2764 2C33.4267 5.24021 29.9069 8.66474 26.7249 12.2393M37.2764 2C40.8906 5.04767 44.4229 8.47897 47.7497 12.2393M37.2764 2L41.6545 20.0116M37.2764 2L33.1141 20.1519M37.4294 128C41.7282 124.282 45.5394 120.531 48.8984 116.763M37.4294 128C32.8814 124.459 28.8281 120.699 25.2593 116.763M37.4294 128L32.7867 108.107M37.4294 128L42.0544 108.55M29.3246 93.2732L22.749 64.078M29.3246 93.2732L5.0039 65.461M29.3246 93.2732L32.7867 108.107M29.3246 93.2732L42.0544 108.55M22.749 64.078L18.1613 49.0195M22.749 64.078L12.8272 98.8049M22.749 64.078L29.6304 35.3439M18.1613 49.0195L13.1299 32.2707M18.1613 49.0195L5.03152 64.078M18.1613 49.0195L29.6304 35.3439M13.1299 32.2707C16.5921 25.2545 21.1379 18.5156 26.7249 12.2393M13.1299 32.2707C8.09389 42.4766 5.35085 53.2692 5.03152 64.078M13.1299 32.2707L33.1141 20.1519M45.6871 93.2732L52.5685 64.078M45.6871 93.2732C45.6871 93.2732 60.503 76.3223 69.9964 65.461M45.6871 93.2732L32.7867 108.107M45.6871 93.2732L42.0544 108.55M52.5685 64.078L56.5444 49.0195M52.5685 64.078L45.3812 35.3439M52.5685 64.078L61.5885 98.8049M56.5444 49.0195L61.4717 32.2707M56.5444 49.0195L69.9678 64.078M56.5444 49.0195L45.3812 35.3439M61.4717 32.2707C66.4123 41.9832 69.6163 52.75 69.9678 64.078M61.4717 32.2707C57.7315 24.9179 52.9961 18.1694 47.7497 12.2393M61.4717 32.2707L41.6545 20.0116M48.8984 116.763C54.2141 110.8 58.3974 104.793 61.5885 98.8049M48.8984 116.763L42.0544 108.55M5.0039 65.461C4.88598 76.8043 7.44338 88.1387 12.8272 98.8049M5.0039 65.461C5.00869 65 5.0179 64.539 5.03152 64.078M25.2593 116.763L32.7867 108.107M25.2593 116.763C20.1211 111.096 15.9873 105.066 12.8272 98.8049M69.9964 65.461C70.1081 76.23 67.6213 87.4843 61.5885 98.8049M69.9964 65.461C69.9916 64.9991 69.9821 64.5381 69.9678 64.078M69.9964 65.461L69.9678 64.078M32.7867 108.107L12.8272 98.8049M29.6304 35.3439L41.6545 20.0116M29.6304 35.3439L33.1141 20.1519M45.3812 35.3439L41.6545 20.0116M45.3812 35.3439L33.1141 20.1519M61.5885 98.8049L42.0544 108.55M26.7249 12.2393L33.1141 20.1519M47.7497 12.2393L41.6545 20.0116" id="Vector-Marquise-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M21.381 1V129M21.381 129H13M21.381 129H29M13 1H29" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="6.23828" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="9.25329" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M4 62.1429L71 62.1429M71 62.1429V70M71 62.1429V55M4 70L4 55" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="55.9756" x="24.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="62.681" x="26.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 107" height="107" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M134.931 27.4878L123.785 22H108.072M134.931 27.4878L149 39.561M134.931 27.4878L129.632 39.561L96.3778 27.8537M134.931 27.4878L108.072 22M149 39.561V42.122M149 39.561H101.677M149 42.122H129.632M149 42.122L106.793 64.8112M74.8173 82L106.793 64.8112M74.8173 82L42.9995 64.8112M74.8173 82L66.3699 68.6463M74.8173 82L83.5622 68.6463M1 42.122V39.561M1 42.122H19.637M1 42.122L42.9995 64.8112M1 39.561L15.9827 27.4878M1 39.561H48.8716M15.9827 27.4878L26.0321 22H41.9284M15.9827 27.4878L19.637 39.561L53.9877 27.8537M15.9827 27.4878L41.9284 22M53.9877 27.8537L74.8173 39.561L96.3778 27.8537M53.9877 27.8537L48.5062 22M53.9877 27.8537L71.3457 22M53.9877 27.8537L48.8716 39.561M96.3778 27.8537L101.494 22M96.3778 27.8537L78.2889 22M96.3778 27.8537L101.677 39.561M108.072 22H101.494M41.9284 22H48.5062M48.5062 22H71.3457M101.494 22H78.2889M78.2889 22H71.3457M48.8716 39.561H101.677M129.632 42.122L106.793 64.8112M129.632 42.122H101.677M129.632 42.122L83.5622 68.6463M101.677 42.122H74.8173M101.677 42.122L83.5622 68.6463M48.8716 42.122H19.637M48.8716 42.122L66.3699 68.6463M48.8716 42.122H74.8173M19.637 42.122L42.9995 64.8112M19.637 42.122L66.3699 68.6463M66.3699 68.6463L74.8173 42.122M74.8173 42.122L83.5622 68.6463" id="Marquise-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M26 11.7619L124 11.7619M124 11.7619V17M124 11.7619V7M26 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M131.762 21V82M131.762 82H126M131.762 82H137M126 21H137" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="65" x="111" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="70.8182" x="113.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="100" x="54.5" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="105.818" x="56.5">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M74.7857 86V96M74.7857 96H68.5M74.7857 96H80.5" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M74.5 76.5C76.9853 76.5 79 78.5147 79 81C79 83.4853 76.9853 85.5 74.5 85.5C72.0147 85.5 70 83.4853 70 81C70 78.5147 72.0147 76.5 74.5 76.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "French Marquise") {

                            // do something for French Marquise

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 71 131" height="131" width="71">

                                <g id="French-Marquise-Plot-Diagram">

                                    <path stroke="black" d="M37.5 2.5L42.4476 22.2906M37.5 2.5L32.6348 22.2906M37.5 2.5L43.6915 9.26178M37.5 2.5L31.3085 9.26178M62.5681 29.877L51.106 34.5772M62.5681 29.877L56.301 23.0327M62.5681 29.877L55.0641 47.8534M62.5681 29.877L64.1314 38.5353M69 65.5L55.0641 60.4699M69 65.5L67.4069 56.6767M69 65.5L55.0641 70.7775M69 65.5L67.4069 74.3233M62.5681 101.123L55.0641 83.1466M62.5681 101.123L64.1909 92.1348M62.5681 101.123L50.9411 96.1754M62.5681 101.123L56.2186 108.057M37.5 128.5L42.3652 108.874M37.5 128.5L32.7173 108.874M37.5 128.5L43.767 121.656M37.5 128.5L31.233 121.656M12.4319 101.123L23.894 96.1754M12.4319 101.123L18.699 107.967M12.4319 101.123L19.9359 83.1466M12.4319 101.123L10.8686 92.4647M6 65.5L19.9359 70.7775M6 65.5L19.9359 60.4699M6 65.5L7.5931 56.6767M6 65.5L7.61667 74.4538M12.4319 29.877L23.9764 34.5772M12.4319 29.877L18.699 23.0327M12.4319 29.877L19.9359 47.8534M12.4319 29.877L10.8686 38.5353M42.4476 22.2906L37.5 36.2264M42.4476 22.2906L44.4267 37.3809M42.4476 22.2906L43.6915 9.26178M42.4476 22.2906L50.034 16.1885M37.5 36.2264L32.6348 22.2906M37.5 36.2264L30.6558 37.3809M37.5 36.2264L44.4267 37.3809M32.6348 22.2906L30.6558 37.3809M32.6348 22.2906L31.3085 9.26178M32.6348 22.2906L24.966 16.1885M30.6558 37.3809L23.9764 34.5772M30.6558 37.3809L29.0065 49.75M44.4267 37.3809L51.106 34.5772M44.4267 37.3809L46.0759 49.75M43.6915 9.26178L50.034 16.1885M31.3085 9.26178L24.966 16.1885M24.966 16.1885L23.9764 34.5772M24.966 16.1885L18.699 23.0327M23.9764 34.5772L18.699 23.0327M23.9764 34.5772L29.0065 49.75M51.106 34.5772L56.301 23.0327M51.106 34.5772L50.034 16.1885M51.106 34.5772L46.0759 49.75M56.301 23.0327L50.034 16.1885M46.0759 49.75L46.8181 58.9856M46.0759 49.75L55.0641 47.8534M46.8181 58.9856L44.0144 65.5M46.8181 58.9856L55.0641 47.8534M46.8181 58.9856L55.0641 60.4699M44.0144 65.5L46.8181 72.1793M44.0144 65.5L55.0641 60.4699M44.0144 65.5L55.0641 70.7775M46.8181 72.1793L55.0641 83.1466M46.8181 72.1793L55.0641 70.7775M46.8181 72.1793L45.8194 81.1675M44.4267 93.7016L37.5 94.9385M44.4267 93.7016L45.8194 81.1675M44.4267 93.7016L50.9411 96.1754M44.4267 93.7016L42.3652 108.874M37.5 94.9385L30.6558 93.7016M37.5 94.9385L42.3652 108.874M37.5 94.9385L32.7173 108.874M30.6558 93.7016L23.894 96.1754M30.6558 93.7016L32.7173 108.874M30.6558 93.7016L29.2631 81.1675M28.2644 72.1793L30.6558 65.5M28.2644 72.1793L19.9359 70.7775M28.2644 72.1793L19.9359 83.1466M28.2644 72.1793L29.2631 81.1675M30.6558 65.5L28.2644 58.9856M30.6558 65.5L19.9359 60.4699M30.6558 65.5L19.9359 70.7775M28.2644 58.9856L29.0065 49.75M28.2644 58.9856L19.9359 60.4699M28.2644 58.9856L19.9359 47.8534M29.0065 49.75L19.9359 47.8534M42.3652 108.874L50.034 114.812M42.3652 108.874L43.767 121.656M32.7173 108.874L31.233 121.656M32.7173 108.874L24.966 114.812M55.0641 47.8534L64.1314 38.5353M55.0641 47.8534H65.8138M64.1314 38.5353L65.8138 47.8534M55.0641 60.4699L65.8138 47.8534M55.0641 60.4699L67.4069 56.6767M65.8138 47.8534L67.4069 56.6767M55.0641 70.7775L67.4069 74.3233M55.0641 70.7775L65.8138 83.1466M67.4069 74.3233L65.8138 83.1466M65.8138 83.1466H55.0641M65.8138 83.1466L64.1909 92.1348M55.0641 83.1466L45.8194 81.1675M55.0641 83.1466L64.1909 92.1348M45.8194 81.1675L50.9411 96.1754M50.9411 96.1754L56.2186 108.057M50.9411 96.1754L50.034 114.812M56.2186 108.057L50.034 114.812M50.034 114.812L43.767 121.656M31.233 121.656L24.966 114.812M24.966 114.812L23.894 96.1754M24.966 114.812L18.699 107.967M23.894 96.1754L29.2631 81.1675M23.894 96.1754L18.699 107.967M19.9359 47.8534L10.8686 38.5353M19.9359 47.8534H9.18619M10.8686 38.5353L9.18619 47.8534M9.18619 47.8534L19.9359 60.4699M9.18619 47.8534L7.5931 56.6767M19.9359 60.4699L7.5931 56.6767M19.9359 70.7775L9.23333 83.4077M19.9359 70.7775L7.61667 74.4538M19.9359 83.1466L29.2631 81.1675M19.9359 83.1466L10.8686 92.4647M19.9359 83.1466L9.23333 83.4077M10.8686 92.4647L9.23333 83.4077M9.23333 83.4077L7.61667 74.4538" id="Vector-French-Marquise-Shape"></path>

                                    

                                    <g id="Container-Length">

                                        <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M21.381 1V130M21.381 130H13M21.381 130H29M13 1H29" id="Handle-Length"></path>

                                        <rect fill="#F8F8F8" rx="2" height="10" width="45" y="83.9756" x="6.23828" id="Length-Rectangle"></rect>

                                        <text font-weight="bold" font-size="5" fill="#565656" y="90.435" x="9.25329" id="Length-Value">Length: ${length}mm</text>

                                    </g>

                                    

                                    <g id="Container-Width">

                                        <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M5 46.6429L70 46.6429M70 46.6429V54.5M70 46.6429V39.5M5 54.5L5 39.5" id="Handle-Width"></path>

                                        <rect fill="#F8F8F8" rx="2" height="10" width="43" y="40.4756" x="24.0176" id="Width-Rectangle"></rect>

                                        <text font-weight="bold" font-size="5" fill="#565656" y="47.1811" x="26.6395" id="Width-Value">Width: ${width}mm</text>

                                    </g>

                                </g>

                            </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 136" height="136" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M53.102 22L1 36.9596M53.102 22H59.3316M53.102 22L43.2857 28.533M53.102 22L35.8291 28.533M97.7474 22L149 36.9596M97.7474 22H91.3291M97.7474 22L115.02 28.533M149 36.9596V41.0309M149 36.9596L115.02 28.533M149 36.9596H141.355M149 41.0309L75.5663 111M149 41.0309H141.355M149 41.0309L106.903 75.3053M75.5663 111L82.9286 75.3053M75.5663 111L67.7321 75.3053M75.5663 111L1 41.0309M75.5663 111L43.2857 75.3053M75.5663 111L53.102 75.3053M75.5663 111L106.903 75.3053M75.5663 111L97.3699 75.8734M1 41.0309V36.9596M1 41.0309L43.2857 75.3053M1 41.0309H8.88138M1 36.9596L35.8291 28.533M1 36.9596H8.88138M82.9286 75.3053L75 41.0309M82.9286 75.3053L104.166 41.0309M82.9286 75.3053L89.5829 41.0309M75 41.0309L67.7321 75.3053M75 41.0309H89.5829M75 41.0309H60.6059M67.7321 75.3053L46.2117 41.0309M67.7321 75.3053L60.6059 41.0309M46.2117 41.0309L53.102 75.3053M46.2117 41.0309H60.6059M46.2117 41.0309H31.4872M53.102 75.3053L16.7628 41.0309M53.102 75.3053L31.4872 41.0309M16.7628 41.0309L43.2857 75.3053M16.7628 41.0309H31.4872M16.7628 41.0309H8.88138M43.2857 75.3053L8.88138 41.0309M104.166 41.0309L97.3699 75.8734M104.166 41.0309H118.937M104.166 41.0309H89.5829M97.3699 75.8734L133.709 41.0309M97.3699 75.8734L118.937 41.0309M133.709 41.0309L106.903 75.3053M133.709 41.0309H141.355M133.709 41.0309H118.937M106.903 75.3053L141.355 41.0309M75 36.9596L64.051 28.533M75 36.9596H61.3138M75 36.9596L86.0456 28.9424M75 36.9596H89.5829M86.6097 28.533L75.4247 22M86.6097 28.533L104.166 36.9596M86.6097 28.533L91.3291 22M86.6097 28.533L86.0456 28.9424M75.4247 22L64.051 28.533M75.4247 22H59.3316M75.4247 22H91.3291M64.051 28.533L59.3316 22M64.051 28.533L61.3138 36.9596M59.3316 22L43.2857 28.533M43.2857 28.533L45.551 36.9596M43.2857 28.533L16.7628 36.9596M43.2857 28.533L31.1569 36.9596M45.551 36.9596H61.3138M45.551 36.9596H31.1569M16.7628 36.9596L35.8291 28.533M16.7628 36.9596H31.1569M16.7628 36.9596H8.88138M35.8291 28.533L8.88138 36.9596M104.166 36.9596L106.903 28.533M104.166 36.9596H89.5829M104.166 36.9596H118.937M91.3291 22L106.903 28.533M106.903 28.533L133.709 36.9596M106.903 28.533L118.937 36.9596M133.709 36.9596L115.02 28.533M133.709 36.9596H118.937M133.709 36.9596H141.355M115.02 28.533L141.355 36.9596M86.0456 28.9424L89.5829 36.9596" id="French-Marquise-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M53 11.7619L98 11.7619M98 11.7619V17M98 11.7619V7M53 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M125.762 22V111M125.762 111H120M125.762 111H131M120 22H131" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="94" x="105" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="99.8182" x="107.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="129" x="56.5" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="134.818" x="57.5">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.7857 115V125M75.7857 125H69.5M75.7857 125H81.5" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75.5 105.5C77.9853 105.5 80 107.515 80 110C80 112.485 77.9853 114.5 75.5 114.5C73.0147 114.5 71 112.485 71 110C71 107.515 73.0147 105.5 75.5 105.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Dutch Marquise") {

                            // do something for Dutch Marquise

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 67 130" height="130" width="67">

                                    <g id="Dutch-Marquise-Plot-Diagram">

                                        <path stroke="black" d="M33.5 2L2 29.4197M33.5 2L65 29.4197M33.5 2V10.487M2 29.4197V100.58M2 29.4197L10.5312 33.3368M65 29.4197V100.58M65 29.4197L56.4688 33.3368M33.5 10.487L10.5312 33.3368M33.5 10.487L56.4688 33.3368M33.5 10.487V20.9326M2 100.58L33.5 128M2 100.58L10.5312 96.0104M10.5312 33.3368V96.0104M10.5312 33.3368L19.0625 36.601M33.5 128L65 100.58M33.5 128V119.513M10.5312 96.0104L33.5 119.513M10.5312 96.0104L19.0625 92.0933M65 100.58L56.4688 96.0104M33.5 119.513L56.4688 96.0104M33.5 119.513V109.067M56.4688 96.0104V33.3368M56.4688 96.0104L48.5938 92.0933M56.4688 33.3368L48.5938 36.601M33.5 20.9326L19.0625 36.601M33.5 20.9326L48.5938 36.601M19.0625 36.601V92.0933M19.0625 92.0933L33.5 109.067M33.5 109.067L48.5938 92.0933M48.5938 92.0933V36.601" id="Vector-Dutch-Marquise-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M14.381 1V129M14.381 129H6M14.381 129H22M6 1H22" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="7.23828" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="10.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 53.1429L66 53.1429M66 53.1429V61M66 53.1429V46M1 61L1 46" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="46.9756" x="18.1357" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="53.681" x="20.7577" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 117" height="117" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M35.7365 22L19.7589 26.9196L1 33.9136M35.7365 22H44.0804M35.7365 22L27.5702 26.5639M114.619 22L130.774 26.9196L149 33.9136M114.619 22H106.334M114.619 22L122.489 26.9196M149 33.9136V38.1219M149 33.9136H137.106M149 38.1219L106.334 64.8535M149 38.1219H137.106M149 38.1219L112.074 65.061M75.1479 92L1 38.1219M75.1479 92L112.074 65.061M75.1479 92L90.7409 78.4268M75.1479 92L84.2019 78.4268M75.1479 92L77.9292 78.4268M75.1479 92L72.2483 78.4268M75.1479 92L65.946 78.4268M75.1479 92L59.2295 78.0907M1 38.1219V33.9136M1 38.1219L44.0804 64.8535M1 38.1219H12.6577M1 33.9136H12.9536M106.334 64.8535L137.106 38.1219M106.334 64.8535L90.7409 78.4268M106.334 64.8535L115.772 51.4877M44.0804 64.8535L12.6577 38.1219M44.0804 64.8535L59.2295 78.0907M44.0804 64.8535L34.4938 51.4877M24.9072 38.1219H38.6066M24.9072 38.1219H12.6577M24.9072 38.1219L40.8257 51.4877M24.9072 38.1219L34.4938 51.4877M56.7441 64.8535L38.6066 38.1219M56.7441 64.8535L65.946 78.4268M56.7441 64.8535L54.525 51.4877M56.7441 64.8535L40.8257 51.4877M52.3059 38.1219H63.7269M52.3059 38.1219H38.6066M52.3059 38.1219L60.8273 51.4877M52.3059 38.1219L54.525 51.4877M69.3487 64.8535L63.7269 38.1219M69.3487 64.8535L72.2483 78.4268M69.3487 64.8535L72.2483 51.4877M69.3487 64.8535L60.8273 51.4877M75.1479 38.1219H86.5098M75.1479 38.1219H63.7269M75.1479 38.1219L77.9292 51.4877M75.1479 38.1219L72.2483 51.4877M80.7105 64.8535L86.5098 38.1219M80.7105 64.8535L77.9292 78.4268M80.7105 64.8535L89.2911 51.4877M80.7105 64.8535L77.9292 51.4877M97.8717 38.1219H111.541M97.8717 38.1219H86.5098M97.8717 38.1219L95.5638 51.4877M97.8717 38.1219L89.2911 51.4877M93.2559 64.8535L111.541 38.1219M93.2559 64.8535L84.2019 78.4268M93.2559 64.8535L109.234 51.4877M93.2559 64.8535L95.5638 51.4877M125.211 38.1219H137.106M125.211 38.1219H111.541M125.211 38.1219L115.772 51.4877M125.211 38.1219L109.234 51.4877M112.074 65.061L90.7409 78.4268M90.7409 78.4268L100.18 64.8535M100.18 64.8535L84.2019 78.4268M100.18 64.8535L115.772 51.4877M100.18 64.8535L109.234 51.4877M84.2019 78.4268L86.5098 64.8535M86.5098 64.8535L77.9292 78.4268M86.5098 64.8535L95.5638 51.4877M86.5098 64.8535L89.2911 51.4877M77.9292 78.4268L75.1479 65.061M75.1479 65.061L72.2483 78.4268M75.1479 65.061L77.9292 51.4877M75.1479 65.061L72.2483 51.4877M72.2483 78.4268L63.7269 65.061M63.7269 65.061L65.946 78.4268M63.7269 65.061L60.8273 51.4877M63.7269 65.061L54.525 51.4877M65.946 78.4268L50.2939 65.061M50.2939 65.061L59.2295 78.0907M50.2939 65.061L40.8257 51.4877M50.2939 65.061L34.4938 51.4877M125.211 33.9136L122.489 26.9196M125.211 33.9136H137.106M125.211 33.9136L104.144 26.9196M125.211 33.9136H97.8717M122.489 26.9196L106.334 22M122.489 26.9196L137.106 33.9136M106.334 22L104.144 26.9196M106.334 22H92.2499M104.144 26.9196L97.8717 33.9136M104.144 26.9196L92.2499 22M97.8717 33.9136L84.4978 26.5639M97.8717 33.9136H75.1479M84.4978 26.5639L92.2499 22M84.4978 26.5639L75.1479 33.9136M84.4978 26.5639L75.1479 22M92.2499 22H75.1479M75.1479 33.9136L65.946 26.5639M75.1479 33.9136H52.3059M65.946 26.5639L75.1479 22M65.946 26.5639L57.9276 22M65.946 26.5639L52.3059 33.9136M75.1479 22H57.9276M57.9276 22L46.0924 26.5639M57.9276 22H44.0804M52.3059 33.9136L46.0924 26.5639M52.3059 33.9136H24.9072M46.0924 26.5639L44.0804 22M46.0924 26.5639L24.9072 33.9136M44.0804 22L27.5702 26.5639M24.9072 33.9136L27.5702 26.5639M24.9072 33.9136H12.9536M27.5702 26.5639L12.9536 33.9136" id="Dutch-Marquise-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M36 11.7619L115 11.7619M115 11.7619V17M115 11.7619V7M36 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M131.762 22V92M131.762 92H126M131.762 92H137M126 22H137" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="76" x="111" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="81.8182" x="113.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="110" x="56" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="115.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 96V106M75.2857 106H69M75.2857 106H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 86.5C77.4853 86.5 79.5 88.5147 79.5 91C79.5 93.4853 77.4853 95.5 75 95.5C72.5147 95.5 70.5 93.4853 70.5 91C70.5 88.5147 72.5147 86.5 75 86.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Oval") {

                            // do something for Oval

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 86 128" height="128" width="86">

                                    <g id="Container-Oval-Plot-Diagram">

                                        <path stroke="black" d="M84.2207 64L72.5515 48.565M84.2207 64L72.5515 79.2775M84.2207 64C84.2207 56.9495 83.467 50.1696 82.0766 43.84M84.2207 64C84.2207 71.0505 83.467 77.8304 82.0766 84.16M43.2207 127L30.9207 108.415M43.2207 127L55.0476 108.415M43.2207 127C37.021 127 31.1427 124.886 25.8746 121.1M43.2207 127C49.5518 127 55.5478 124.795 60.9011 120.857M2.2207 64L13.5745 48.565M2.2207 64L13.5745 79.2775M2.2207 64C2.2207 56.9495 2.97443 50.1696 4.36482 43.84M2.2207 64C2.2207 71.0505 2.97443 77.8304 4.36482 84.16M43.2207 1L30.9207 18.7975M43.2207 1L55.0476 18.7975M43.2207 1C49.5518 1 55.5478 3.20501 60.9011 7.1425M43.2207 1C31.4954 1 20.9197 8.56302 13.447 20.6875M30.9207 108.415L43.063 99.4375M30.9207 108.415L25.8746 121.1M30.9207 108.415L25.9888 87.9872M30.9207 108.415L13.064 106.682M20.1976 64L25.9888 39.5875M20.1976 64L25.9888 87.9872M20.1976 64L13.5745 48.565M20.1976 64L13.5745 79.2775M30.9207 18.7975L43.063 27.9325M30.9207 18.7975L25.8746 7.1425M30.9207 18.7975L25.9888 39.5875M30.9207 18.7975L13.447 20.6875M55.0476 18.7975L60.1246 39.5875M55.0476 18.7975L43.063 27.9325M55.0476 18.7975L60.9011 7.1425M55.0476 18.7975L72.9944 20.6875M66.0861 64L60.1246 39.5875M66.0861 64L60.1246 87.9872M66.0861 64L72.5515 79.2775M66.0861 64L72.5515 48.565M55.0476 108.415L60.1246 87.9872M55.0476 108.415L43.063 99.4375M55.0476 108.415L60.9011 120.857M55.0476 108.415L73.3774 106.682M72.5515 48.565L60.1246 39.5875M72.5515 48.565L72.9944 20.6875M72.5515 48.565L82.0766 43.84M60.1246 39.5875L43.063 27.9325M43.063 27.9325L25.9888 39.5875M72.5515 79.2775L60.1246 87.9872M72.5515 79.2775L73.3774 106.682M72.5515 79.2775L82.0766 84.16M60.1246 87.9872L43.063 99.4375M43.063 99.4375L25.9888 87.9872M25.8746 121.1C21.0077 117.604 16.6617 112.681 13.064 106.682M13.5745 48.565L25.9888 39.5875M13.5745 48.565L13.447 20.6875M13.5745 48.565L4.36482 43.84M60.9011 7.1425C65.4621 10.4973 69.5566 15.1097 72.9944 20.6875M13.5745 79.2775L25.9888 87.9872M13.5745 79.2775L13.064 106.682M13.5745 79.2775L4.36482 84.16M60.9011 120.857C65.6327 117.377 69.8623 112.543 73.3774 106.682M13.064 106.682C9.2145 100.264 6.22182 92.6137 4.36482 84.16M73.3774 106.682C77.2269 100.264 80.2196 92.6137 82.0766 84.16M72.9944 20.6875C77.0286 27.233 80.1584 35.1079 82.0766 43.84M13.447 20.6875C9.41281 27.233 6.28296 35.1079 4.36482 43.84" id="Oval-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M21.6017 1V127M21.6017 127H13.2207M21.6017 127H29.2207M13.2207 1H29.2207" id="Handle-Length"></path>

                                            <g id="Container-Length-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="45" y="81.9756" x="6.23828" id="Length-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Length-Value">

                                                    <tspan y="88.4349" x="9.25329">Length: ${length}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1.7207 64.1429L84.7207 64.1429M84.7207 64.1429V72M84.7207 64.1429V57M1.7207 72L1.7207 57" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="42.7425" y="57.9756" x="22.6125" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="64.681" x="25.1057">Width: ${width}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 116" height="116" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 39.4316V44.1526M149 39.4316H138.905M149 39.4316L133.136 26.6484M149 44.1526L134.579 56.5M149 44.1526H138.905M134.579 56.5L103.212 75.3842M134.579 56.5L138.905 44.1526M103.212 75.3842L75.4507 91M103.212 75.3842L138.905 44.1526M103.212 75.3842L125.205 44.1526M75.4507 91L46.9683 75.3842M75.4507 91L125.205 44.1526M75.4507 91L102.491 44.1526M75.4507 91L48.0499 44.1526M75.4507 91L25.877 44.1526M75.4507 91L75.2704 44.1526M46.9683 75.3842L15.9622 56.5M46.9683 75.3842L25.877 44.1526M46.9683 75.3842L11.9963 44.1526M15.9622 56.5L1 44.1526M15.9622 56.5L11.9963 44.1526M1 44.1526V39.4316M1 44.1526H11.9963M1 39.4316H11.9963M1 39.4316L17.5246 26.6484M138.905 39.4316L133.136 26.6484M138.905 39.4316H125.205M133.136 26.6484L127.368 22H113.307M133.136 26.6484L125.205 39.4316M133.136 26.6484L113.307 22M125.205 39.4316H123.582M113.307 22H111.324M111.324 22L96.1815 27.4474M111.324 22H79.2363M96.1815 27.4474L75.4507 39.4316M96.1815 27.4474L123.582 39.4316M96.1815 27.4474L102.491 39.4316M96.1815 27.4474L79.2363 22M75.4507 39.4316L54.7559 27.2658M75.4507 39.4316H48.0499M75.4507 39.4316H102.491M54.7559 27.2658L40.1181 22M54.7559 27.2658L48.0499 39.4316M54.7559 27.2658L25.877 39.4316M54.7559 27.2658L72.5664 22M40.1181 22H37.2339M40.1181 22H72.5664M48.0499 39.4316H25.877M25.877 39.4316H11.9963M25.877 39.4316L17.5246 26.6484M11.9963 39.4316L17.5246 26.6484M17.5246 26.6484L23.5335 22H37.2339M17.5246 26.6484L37.2339 22M123.582 39.4316H102.491M79.2363 22H72.5664M138.905 44.1526H125.205M125.205 44.1526H102.491M102.491 44.1526H75.2704M48.0499 44.1526H25.877M48.0499 44.1526H75.2704M25.877 44.1526H11.9963" id="Oval-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M23 11.7619L128 11.7619M128 11.7619V17M128 11.7619V7M23 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M130.762 21V91M130.762 91H125M130.762 91H136M125 21H136" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="76" x="110" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="81.8182" x="112.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="109" x="55.5" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="114.818" x="57.5">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.7857 95V105M75.7857 105H69.5M75.7857 105H81.5" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75.5 85.5C77.9853 85.5 80 87.5147 80 90C80 92.4853 77.9853 94.5 75.5 94.5C73.0147 94.5 71 92.4853 71 90C71 87.5147 73.0147 85.5 75.5 85.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Moval") {

                            // do something for Moval

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 72 130" height="130" width="72">

                                    <g id="Moval-Plot-Diagram">

                                        <path stroke="black" d="M36 2L42.4683 3.07339L48.9366 6.62385M36 2L29.3659 3.07339L23.0634 6.62385M36 2L46.5317 18.1009M36 2L25.5512 18.1009M36 2V27.0183M48.9366 6.62385L54.9902 12.5688L60.0488 20.4954M48.9366 6.62385L46.5317 18.1009M60.0488 20.4954L64.1951 29.7431L67.3463 41.055M60.0488 20.4954L46.5317 18.1009M60.0488 20.4954L61.2098 45.5963M67.3463 41.055L69.3366 52.7798L70 65.0826M67.3463 41.055L61.2098 45.5963M70 65.0826L69.3366 77.7156L67.3463 88.8624M70 65.0826L61.2098 45.5963M70 65.0826H56.4M70 65.0826L61.2927 84.5688M67.3463 88.8624L64.1951 100.009L60.0488 109.505M67.3463 88.8624L61.2927 84.5688M60.0488 109.505L54.9902 117.596L48.9366 123.211M60.0488 109.505L61.2927 84.5688M60.0488 109.505L46.4488 111.899M48.9366 123.211L42.4683 127.009L36 128M48.9366 123.211L46.4488 111.899M36 128L29.2 127.009L22.8146 123.211M36 128L46.4488 111.899M36 128L25.5512 111.899M36 128V102.899M22.8146 123.211L17.1756 117.596L11.8683 109.505M22.8146 123.211L25.5512 111.899M11.8683 109.505L7.63902 100.009L4.4878 88.8624M11.8683 109.505L10.7902 84.5688M11.8683 109.505L25.5512 111.899M4.4878 88.8624L2.66341 77.7156L2 65.0826M4.4878 88.8624L10.7902 84.5688M2 65.0826L2.66341 52.7798L4.57073 41.055M2 65.0826H15.6M2 65.0826L10.7073 45.5963M2 65.0826L10.7902 84.5688M4.57073 41.055L7.88781 29.7431L11.8683 20.4954M4.57073 41.055L10.7073 45.5963M11.8683 20.4954L17.0927 12.5688L23.0634 6.62385M11.8683 20.4954L10.7073 45.5963M11.8683 20.4954L25.5512 18.1009M23.0634 6.62385L25.5512 18.1009M46.5317 18.1009L50.4293 38.4128M46.5317 18.1009L36 27.0183M50.4293 38.4128L56.4 65.0826M50.4293 38.4128L61.2098 45.5963M50.4293 38.4128L36 27.0183M56.4 65.0826L50.4293 91.8349M56.4 65.0826L61.2098 45.5963M56.4 65.0826L61.2927 84.5688M50.4293 91.8349L46.4488 111.899M50.4293 91.8349L61.2927 84.5688M50.4293 91.8349L36 102.899M46.4488 111.899L36 102.899M25.5512 111.899L21.5707 91.8349M25.5512 111.899L36 102.899M21.5707 91.8349L15.6 65.0826M21.5707 91.8349L36 102.899M21.5707 91.8349L10.7902 84.5688M15.6 65.0826L21.4878 38.4128M15.6 65.0826L10.7073 45.5963M15.6 65.0826L10.7902 84.5688M21.4878 38.4128L25.5512 18.1009M21.4878 38.4128L10.7073 45.5963M21.4878 38.4128L36 27.0183M25.5512 18.1009L36 27.0183" id="Vector-Moval-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M22.381 1V129M22.381 129H14M22.381 129H30M14 1H30" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="7.23828" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="10.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 53.1429L71 53.1429M71 53.1429V61M71 53.1429V46M1 61L1 46" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="46.9756" x="25.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="53.681" x="27.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 151" height="151" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 46.9243V52.7697M149 46.9243L130.195 31.0117M149 46.9243H143.336M149 52.7697L90.8929 110.493M149 52.7697H143.336M75.2832 126V116.826M75.2832 126L59.5536 110.493M75.2832 126L90.8929 110.493M1 52.7697V46.9243M1 52.7697L59.5536 110.493M1 52.7697H7.06889M1 46.9243L19.9081 31.0117M1 46.9243H7.06889M75.2832 52.7697H46.9617M75.2832 52.7697V116.826M75.2832 52.7697H102.957M46.9617 52.7697L75.2832 116.826M46.9617 52.7697H23.9809M75.2832 116.826L23.9809 52.7697M75.2832 116.826L102.957 52.7697M75.2832 116.826L127.557 52.7697M23.9809 52.7697L59.5536 110.493M23.9809 52.7697H7.06889M59.5536 110.493L7.06889 52.7697M102.957 52.7697H127.557M127.557 52.7697L90.8929 110.493M127.557 52.7697H143.336M90.8929 110.493L143.336 52.7697M75.0809 22L52.2214 31.0117M75.0809 22H43.5631M75.0809 22L97.8595 31.0117M75.0809 22H106.437M52.2214 31.0117L23.9809 46.9243M52.2214 31.0117L43.5631 22M52.2214 31.0117L75.0809 46.9243M52.2214 31.0117L46.9617 46.9243M23.9809 46.9243L19.9081 31.0117M23.9809 46.9243H7.06889M23.9809 46.9243H46.9617M19.9081 31.0117L30.6162 22H43.5631M19.9081 31.0117L43.5631 22M19.9081 31.0117L7.06889 46.9243M97.8595 31.0117L127.557 46.9243M97.8595 31.0117L75.0809 46.9243M97.8595 31.0117L106.437 22M97.8595 31.0117L102.957 46.9243M127.557 46.9243L130.195 31.0117M127.557 46.9243H143.336M127.557 46.9243H102.957M75.0809 46.9243H46.9617M75.0809 46.9243H102.957M106.437 22H119.546L130.195 31.0117M106.437 22L130.195 31.0117M130.195 31.0117L143.336 46.9243" id="Moval-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M30 11.7619L120 11.7619M120 11.7619V17M120 11.7619V7M30 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M132.762 22V126M132.762 126H127M132.762 126H138M127 22H138" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="106" x="112" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="111.818" x="114.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="144" x="56" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="149.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 130V140M75.2857 140H69M75.2857 140H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 120.5C77.4853 120.5 79.5 122.515 79.5 125C79.5 127.485 77.4853 129.5 75 129.5C72.5147 129.5 70.5 127.485 70.5 125C70.5 122.515 72.5147 120.5 75 120.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Pear") {

                            // do something for Pear

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 85 131" height="131" width="85">

                                    <g id="Pear-Plot-Diagram">

                                        <path stroke="black" d="M43.0315 3L50.7567 28.6925M43.0315 3L36.0805 28.6925M43.0315 3C48.3808 8.32706 53.2934 14.0889 57.7086 20.1159M43.0315 3C37.6878 8.32163 32.7562 14.0841 28.3063 20.1159M43.0315 129L51.6836 111.462M43.0315 129L34.5356 111.462M43.0315 129C35.6134 129 29.3062 127.852 24.0305 125.75M43.0315 129C50.2526 129 56.4119 127.852 61.5794 125.75M50.7567 28.6925L56.4727 52.8463M50.7567 28.6925L70.2895 40.5386M50.7567 28.6925L57.7086 20.1159M50.7567 28.6925L43.0315 37.4617M56.4727 52.8463L64.6605 79.154M56.4727 52.8463L67.7503 66.2309M56.4727 52.8463L43.0315 37.4617M64.6605 79.154L68.9862 94.5386M64.6605 79.154L57.7086 99.3078M64.6605 79.154L67.7503 66.2309M68.9862 94.5386L75.8152 114.692M68.9862 94.5386L83.1629 85.3078M68.9862 94.5386L57.7086 99.3078M75.8152 114.692C81.3309 107.025 83.6247 96.796 83.1629 85.3078M75.8152 114.692C72.3671 119.486 67.6598 123.278 61.5794 125.75M75.8152 114.692L51.6836 111.462M36.0805 28.6925L29.7465 52.8463M36.0805 28.6925L15.5826 40.5386M36.0805 28.6925L43.0315 37.4617M36.0805 28.6925L28.3063 20.1159M29.7465 52.8463L22.1767 79.154M29.7465 52.8463L43.0315 37.4617M29.7465 52.8463L19.0869 66.2309M22.1767 79.154L17.3876 94.5386M22.1767 79.154L19.0869 66.2309M22.1767 79.154L28.9741 99.3078M17.3876 94.5386L9.56183 114.692M17.3876 94.5386L2.30209 85.3078M17.3876 94.5386L28.9741 99.3078M9.56183 114.692C3.99291 107.024 1.74958 96.7939 2.30209 85.3078M9.56183 114.692C13.0425 119.485 17.8223 123.278 24.0305 125.75M9.56183 114.692L34.5356 111.462M51.6836 111.462L57.7086 99.3078M51.6836 111.462L43.0315 105.462M51.6836 111.462L61.5794 125.75M57.7086 99.3078L43.0315 105.462M67.7503 66.2309L70.2895 40.5386M67.7503 66.2309L83.1629 85.3078M70.2895 40.5386C78.0423 55.7696 82.6061 71.4542 83.1629 85.3078M70.2895 40.5386C66.7386 33.5627 62.5188 26.682 57.7086 20.1159M15.5826 40.5386L19.0869 66.2309M15.5826 40.5386C7.70576 55.7612 2.96874 71.4488 2.30209 85.3078M15.5826 40.5386C19.1938 33.5596 23.4649 26.6784 28.3063 20.1159M19.0869 66.2309L2.30209 85.3078M28.9741 99.3078L34.5356 111.462M28.9741 99.3078L43.0315 105.462M34.5356 111.462L43.0315 105.462M34.5356 111.462L24.0305 125.75" id="Vector-Pear-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M22.6017 1V130M22.6017 130H14.2207M22.6017 130H30.2207M14.2207 1H30.2207" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="7.23828" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="10.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1.2207 65.1429L84.2207 65.1429M84.2207 65.1429V73M84.2207 65.1429V58M1.2207 73L1.2207 58" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="58.9756" x="34.2383" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="65.681" x="36.8602" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 152 117" height="117" width="152">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M127.054 22L136.667 30.3189M127.054 22L123.789 28.6925M127.054 22H109.824M149 40.9922V44.2481M149 40.9922L136.667 30.3189M149 40.9922L117.804 40.4966M149 44.2481L121.794 71.3798M149 44.2481L135.578 44.1004M121.794 71.3798L94.951 92M121.794 71.3798L135.578 44.1004M121.794 71.3798L117.804 43.9049M94.951 92L1 42.6202M94.951 92L96.9461 71.3798M94.951 92L79.3529 71.3798M94.951 92L48.701 58.8992M1 42.6202V38.6408M1 42.6202L48.701 58.8992M1 42.6202L36.0049 43.0052M1 38.6408L14.4216 28.6925M1 38.6408L36.0049 39.197M14.4216 28.6925L38.5441 22H55.7745M14.4216 28.6925L36.0049 39.197M14.4216 28.6925L55.7745 22M135.578 44.1004L117.804 43.9049M117.804 43.9049L96.9461 71.3798M117.804 43.9049L100.029 43.7094M96.9461 71.3798L100.029 43.7094M96.9461 71.3798L79.3529 43.482M100.029 43.7094L79.3529 43.482M79.3529 43.482V71.3798M79.3529 43.482L55.7745 43.2226M79.3529 71.3798L55.7745 43.2226M79.3529 71.3798L36.0049 43.0052M55.7745 43.2226L36.0049 43.0052M48.701 58.8992L36.0049 43.0052M136.667 30.3189L135.578 40.0879L123.789 28.6925M123.789 28.6925L117.804 40.4966M123.789 28.6925L109.824 22M117.804 40.4966L100.029 28.6925M117.804 40.4966L100.029 40.2142M100.029 28.6925L109.824 22M100.029 28.6925V40.2142M100.029 28.6925L79.3529 22M100.029 28.6925L79.3529 39.8857M109.824 22H79.3529M100.029 40.2142L79.3529 39.8857M79.3529 22L55.7745 30.3189M79.3529 22H55.7745M79.3529 39.8857L55.7745 30.3189M79.3529 39.8857L55.7745 39.5111M55.7745 30.3189V39.5111M55.7745 30.3189V22M55.7745 30.3189L36.0049 39.197M55.7745 39.5111L36.0049 39.197" id="Pear-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M38 11.7619L127 11.7619M127 11.7619V17M127 11.7619V7M38 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="65" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="68.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M134.762 21V92M134.762 92H129M134.762 92H140M129 21H140" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="75" x="114" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="80.8182" x="116.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="110" x="75" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="115.818" x="77">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M95.2857 96V106M95.2857 106H89M95.2857 106H101" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M95 86.5C97.4853 86.5 99.5 88.5147 99.5 91C99.5 93.4853 97.4853 95.5 95 95.5C92.5147 95.5 90.5 93.4853 90.5 91C90.5 88.5147 92.5147 86.5 95 86.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Princess") {

                            // do something for Princess

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 130" height="130" width="130">

                                    <g id="Container-Princess-Plot-Diagram">

                                        <path stroke="black" d="M2 2H128M2 2V128M2 2L91.5793 38.8212M2 2L16.8066 38.1998M128 2V128M128 2L38.7306 38.1998M128 2L113.066 38.8212M128 128H2M128 128L91.5793 113.231M128 128L113.066 91.4336M2 128L16.8066 91.8002M2 128L38.7306 113.157M91.5793 38.8212V16.6042H38.7306V38.1998M91.5793 38.8212H113.066M91.5793 38.8212L113.066 91.4336M38.7306 38.1998H16.8066M38.7306 38.1998L16.8066 91.8002M91.5793 91.8002L113.066 38.8212M91.5793 91.8002L38.7306 113.157M91.5793 91.8002V113.231M91.5793 91.8002L113.066 91.4336M38.7306 91.8002L16.8066 38.1998M38.7306 91.8002H16.8066M38.7306 91.8002V113.157M38.7306 91.8002L91.5793 113.231M113.066 38.8212V91.4336M16.8066 38.1998V91.8002M38.7306 113.157L91.5793 113.231" id="Princess-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M28.381 1V129M28.381 129H20M28.381 129H36M20 1H36" id="Handle-Length"></path>

                                            <g id="Container-Length-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="45" y="81.9756" x="13.0176" id="Length-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Length-Value">

                                                    <tspan y="88.4349" x="16.0326">Length: ${length}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 51.1429L129 51.1429M129 51.1429V59M129 51.1429V44M1 59L1 44" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="43" y="44.9748" x="43.0176" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="51.6803" x="45.6395">Width: ${width}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 131" height="131" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 35.2821L128.216 22H117.644M149 35.2821V38.1538M149 35.2821L117.644 29.6609M149 35.2821H1M149 38.1538L131.441 67.9487L95.247 97.0256M149 38.1538H1M149 38.1538L75 73.5128M149 38.1538L75 81.0513M149 38.1538L75 93.5256M149 38.1538L95.247 97.0256M95.247 97.0256L75 106M75 106L54.9322 97.0256M75 106V93.5256M54.9322 97.0256L18.7385 67.9487L1 38.1538M54.9322 97.0256L1 38.1538M1 38.1538V35.2821M1 38.1538L75 73.5128M1 38.1538L75 81.0513M1 38.1538L75 93.5256M1 35.2821L13.7845 27.3846M1 35.2821L32.1768 29.6794M136.458 27.3846L117.644 22M117.644 22H74.9104M117.644 22V29.6609M13.7845 27.3846L22.5012 22H32.1768M13.7845 27.3846L32.1768 22M32.1768 22H74.9104M32.1768 22V29.6794M74.9104 22L117.644 29.6609M74.9104 22L32.2801 29.6609M32.1768 29.6794L32.2801 29.6609M117.644 29.6609H32.2801M75 73.5128V81.0513M75 81.0513V93.5256" id="Princess-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M22 11.7619L128 11.7619M128 11.7619V17M128 11.7619V7M22 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M132.762 21V106M132.762 106H127M132.762 106H138M127 21H138" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="84" x="112" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="89.8182" x="114.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="124" x="55" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="129.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 110V120M75.2857 120H69M75.2857 120H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 100.5C77.4853 100.5 79.5 102.515 79.5 105C79.5 107.485 77.4853 109.5 75 109.5C72.5147 109.5 70.5 107.485 70.5 105C70.5 102.515 72.5147 100.5 75 100.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Portuguese") {

                            // do something for Portuguese

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 130" height="130" width="130">

                                    <g id="Portuguese-Plot-Diagram">

                                        <path stroke="black" d="M51.6731 2H77.5192M51.6731 2L28.6538 11.2885M51.6731 2C40.0423 22.6769 40.0962 42.1154 41.5769 49.25M51.6731 2C59.2115 6.57692 75.3385 20.8192 79.5385 41.1731M77.5192 2L100.942 11.2885M77.5192 2C57.4885 14.9231 50.8654 33.5 50.0577 41.1731M77.5192 2C82.2308 8.32692 90.8461 26.6346 87.6154 49.25M100.942 11.2885L118.712 29.0577M100.942 11.2885C78.0038 16.7808 63.1154 31.0769 58.5385 37.5385M100.942 11.2885C102.154 20.5769 102.073 42.95 92.0577 58.1346M118.712 29.0577L128 50.8654M118.712 29.0577C94.1577 24.8577 76.1731 32.9615 70.25 37.5385M118.712 29.0577C117.096 37 109.504 56.3577 92.0577 70.25M128 50.8654V78.3269M128 50.8654C106.354 39.5577 86.6731 39.6923 79.5385 41.1731M128 50.8654C123.962 58.5385 110.392 74.9346 88.4231 79.1346M128 78.3269L118.712 100.538M128 78.3269C112.492 56.3577 94.6154 49.7885 87.6154 49.25M128 78.3269C120.073 82.5571 99.2469 90.3541 79.3594 87.701M118.712 100.538L100.942 117.5M118.712 100.538C112.25 78.2462 98.25 62.9808 92.0577 58.1346M118.712 100.538C109.692 101.615 87.3731 101.427 70.25 92.0577M100.942 117.5C102.235 87.4538 95.5577 73.4808 92.0577 70.25M100.942 117.5C92.7308 116.288 72.7538 109.504 58.5385 92.0577M100.942 117.5L77.5192 128M77.5192 128H51.6731M77.5192 128C88.8269 110.877 89.5 88.2885 88.4231 79.1346M77.5192 128C56.805 113.01 50.6997 94.7779 50.0577 87.6154M51.6731 128L28.6538 117.5M51.6731 128C40.3654 109.908 40.2308 87.8846 41.5769 79.1346M51.6731 128C58.5537 123.076 73.7238 108.446 79.3594 87.701M28.6538 117.5L12.0962 100.538M28.6538 117.5C26.7154 91.0077 33.5 74.9615 37.1346 70.25M28.6538 117.5C33.9038 117.769 49.5731 113.058 70.25 92.0577M12.0962 100.538L2 78.3269M12.0962 100.538C13.0654 84.0615 29.1923 65.4039 37.1346 58.1346M12.0962 100.538C19.6346 102.019 39.4769 102.396 58.5385 92.0577M2 78.3269V50.8654M2 78.3269C13.6308 59.2654 33.2308 51 41.5769 49.25M2 78.3269C10.75 82.6346 32.6115 90.5231 50.0577 87.6154M2 50.8654L12.0962 29.0577M2 50.8654C19.4462 41.1731 41.3077 40.3654 50.0577 41.1731M2 50.8654C6.03846 58.8077 19.6077 75.5808 41.5769 79.1346M12.0962 29.0577L28.6538 11.2885M12.0962 29.0577C41.8192 25.8269 55.4423 33.3654 58.5385 37.5385M12.0962 29.0577C12.5 36.3269 18.0731 54.7423 37.1346 70.25M28.6538 11.2885C27.1731 21.25 26.7962 44.5654 37.1346 58.1346M28.6538 11.2885C36.7308 12.9038 56.3577 20.4154 70.25 37.5385M58.5385 37.5385H70.25M58.5385 37.5385L50.0577 41.1731M70.25 37.5385L79.5385 41.1731M79.5385 41.1731L87.6154 49.25M87.6154 49.25L92.0577 58.1346M92.0577 58.1346V70.25M92.0577 70.25L88.4231 79.1346M88.4231 79.1346L79.5385 87.6154L79.3594 87.701M70.25 92.0577H58.5385M70.25 92.0577L79.3594 87.701M58.5385 92.0577L50.0577 87.6154M50.0577 87.6154L41.5769 79.1346M41.5769 79.1346L37.1346 70.25M37.1346 70.25V58.1346M37.1346 58.1346L41.5769 49.25M41.5769 49.25L50.0577 41.1731" id="Vector-Portuguese-Shape"></path>

                                        

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M38.381 1V129M38.381 129H30M38.381 129H46M30 1H46" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="23.2383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="26.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 62.1429L129 62.1429M129 62.1429V70M129 62.1429V55M1 70L1 55" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="55.9756" x="53.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="62.681" x="55.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 144" height="144" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M36.6691 22L14.2108 35.2551M36.6691 22L25.4892 33.9918M36.6691 22H42.259M113.065 22L135.691 35.2551M113.065 22H108.273M113.065 22L123.978 32.6593M149 43.0522V47.3159M149 43.0522H142.612M149 43.0522L135.691 35.2551M149 47.3159H141.547M149 47.3159L132.613 63.3049M75.5324 119L63.0216 98.7473M75.5324 119L88.0432 98.7473M75.5324 119L94.964 97.1484M75.5324 119L109.871 85.4955M75.5324 119L39.7901 84.6236M75.5324 119L55.5684 97.1484M75.5324 119L79.259 98.7473M75.5324 119L70.4748 98.7473M1 47.3159V43.0522M1 47.3159H7.65468M1 47.3159L17.6243 63.3049M1 43.0522H7.65468M1 43.0522L14.2108 35.2551M7.65468 47.3159L17.6243 63.3049M7.65468 47.3159L28.6835 65.9698M7.65468 47.3159H24.4245M17.6243 63.3049L39.7901 84.6236M28.6835 65.9698L48.6475 84.6236M28.6835 65.9698L39.7901 84.6236M28.6835 65.9698L24.4245 47.3159M48.6475 84.6236L63.0216 98.7473M48.6475 84.6236L55.5684 97.1484M48.6475 84.6236L44.6547 65.9698M63.0216 98.7473L60.6259 84.6236M141.547 47.3159L132.613 63.3049M141.547 47.3159L121.849 65.9698M141.547 47.3159H125.842M132.613 63.3049L109.871 85.4955M121.849 65.9698L101.885 84.6236M121.849 65.9698L109.871 85.4955M121.849 65.9698L125.842 47.3159M101.885 84.6236L88.0432 98.7473M101.885 84.6236L94.964 97.1484M101.885 84.6236L105.878 65.9698M88.0432 98.7473L90.1727 84.6236M94.964 97.1484L109.871 85.4955M39.7901 84.6236L55.5684 97.1484M24.4245 47.3159L44.6547 65.9698M24.4245 47.3159H47.3165M44.6547 65.9698L47.3165 47.3159M44.6547 65.9698L60.6259 84.6236M47.3165 47.3159L64.0863 65.9698M47.3165 47.3159H75.5324M64.0863 65.9698L75.5324 47.3159M64.0863 65.9698L75.5324 83.0247M64.0863 65.9698L60.6259 84.6236M75.5324 47.3159L86.1799 65.9698M75.5324 47.3159H103.216M86.1799 65.9698L103.216 47.3159M86.1799 65.9698L90.1727 84.6236M86.1799 65.9698L75.5324 83.0247M103.216 47.3159L105.878 65.9698M103.216 47.3159H125.842M105.878 65.9698L125.842 47.3159M105.878 65.9698L90.1727 84.6236M90.1727 84.6236L79.259 98.7473M60.6259 84.6236L70.4748 98.7473M79.259 98.7473L75.5324 83.0247M75.5324 83.0247L70.4748 98.7473M142.612 43.0522L135.691 35.2551M142.612 43.0522L123.978 32.6593M142.612 43.0522H125.842M123.978 32.6593L125.842 43.0522M123.978 32.6593L98.9568 22M125.842 43.0522L108.273 33.9918M125.842 43.0522H103.216M108.273 33.9918L103.216 43.0522M108.273 33.9918L82.9856 22M108.273 33.9918V22M103.216 43.0522L86.1799 33.9918M103.216 43.0522H75.5324M86.1799 33.9918L75.5324 43.0522M86.1799 33.9918L97.0935 22M86.1799 33.9918L67.946 22M75.5324 43.0522L64.0863 33.9918M75.5324 43.0522H47.3165M64.0863 33.9918L47.3165 43.0522M64.0863 33.9918L82.9856 22M64.0863 33.9918L57.13 26.5302M47.3165 43.0522L42.259 33.9918M47.3165 43.0522H24.1583M42.259 33.9918L24.1583 43.0522M42.259 33.9918L57.13 26.5302M42.259 33.9918L42.5488 26.5302M24.1583 43.0522L25.4892 33.9918M24.1583 43.0522H7.65468M25.4892 33.9918L7.65468 43.0522M25.4892 33.9918L42.5488 26.5302M7.65468 43.0522L14.2108 35.2551M52.9065 22H67.946M52.9065 22L57.13 26.5302M52.9065 22L42.5488 26.5302M52.9065 22H42.259M82.9856 22H97.0935M82.9856 22H67.946M108.273 22H98.9568M98.9568 22H97.0935M67.946 22L57.13 26.5302M42.5488 26.5302L42.259 22" id="Portuguese-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M36 11.7619L113 11.7619M113 11.7619V17M113 11.7619V7M36 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="57" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="60.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M130.762 22V119M130.762 119H125M130.762 119H136M125 22H136" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="96" x="110" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="101.818" x="112.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="137" x="56.5" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="142.818" x="57.5">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.7857 123V133M75.7857 133H69.5M75.7857 133H81.5" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75.5 113.5C77.9853 113.5 80 115.515 80 118C80 120.485 77.9853 122.5 75.5 122.5C73.0147 122.5 71 120.485 71 118C71 115.515 73.0147 113.5 75.5 113.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Round") {

                            // do something for Round

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 129 129" height="129" width="129">

                                    <g id="Container-Plot-Diagram">

                                        <g id="Container-Round-Shape">

                                            <path stroke="black" d="M25.1097 47.593L2.79724 63.9992L25.1097 80.4054L7.39099 88.2804" id="Round-Path-1"></path>

                                            <path stroke="black" d="M25.1084 80.4055L20.5146 107.312L48.0771 103.374L40.2021 121.093" id="Round-Path-2"></path>

                                            <path stroke="black" d="M42.1694 41.0297C47.4194 35.7797 48.0757 24.6234 48.0757 24.6234C48.0757 24.6234 55.9506 31.8422 63.8256 31.8422C71.7006 31.8422 80.8881 24.6234 80.8881 24.6234C80.8881 24.6234 80.2319 34.4672 87.4506 41.0297C94.6693 47.5922 103.857 47.5922 103.857 47.5922C103.857 47.5922 96.6381 53.4984 96.6381 63.9984C96.6381 74.4984 103.857 80.4046 103.857 80.4046C103.857 80.4046 94.6693 80.4046 87.4506 86.9671C80.2319 93.5296 80.8881 103.373 80.8881 103.373C80.8881 103.373 73.6694 96.1546 63.8256 96.1546C53.9819 96.1546 48.0757 103.373 48.0757 103.373C48.0757 103.373 48.0757 92.2171 40.8569 86.3109C33.6382 80.4046 25.1069 80.4046 25.1069 80.4046C25.1069 80.4046 32.3257 71.8734 32.3257 63.9984C32.3257 56.1234 25.1069 47.5922 25.1069 47.5922C25.1069 47.5922 36.9194 46.2797 42.1694 41.0297Z" id="Round-Path-3"></path>

                                            <path stroke="black" d="M48.0775 103.375L64.4837 125.688L80.89 103.375L88.765 121.094" id="Round-Path-4"></path>

                                            <circle stroke="black" r="62.4999" cy="63.9999" cx="64.4815" id="Outer-Round-Circle"></circle>

                                            <circle stroke="black" r="32.3125" cy="63.9999" cx="64.4804" id="Inner-Round-Circle"></circle>

                                            <path stroke="black" d="M40.2036 6.24833L48.0786 24.6233L63.8286 2.31084L80.8911 24.6233M80.8911 103.373L107.797 107.967L103.86 80.4045M103.86 80.4045L121.579 88.2795M103.86 80.4045L126.172 63.9983L103.86 47.592M103.86 47.592L121.579 39.717M103.86 47.592L107.797 20.6858L80.8911 24.6233M80.8911 24.6233L88.7661 6.90458" id="Round-Path-5"></path>

                                            <path stroke="black" d="M48.0784 24.6244L21.1722 20.0306L25.1097 47.5931L6.73474 39.0619" id="Round-Path-6"></path>

                                        </g>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M35.3728 1.02441V128M35.3728 128H26.9941M35.3728 128H42.9897M26.9941 1.02441H42.9897" id="Handle-Length"></path>

                                            <g id="Container-Length-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="45" y="82" x="20" id="Length-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Length-Value">

                                                    <tspan y="88.4594" x="23.015">Length: ${length}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M0.982422 65.1543L127.982 65.1543M127.982 65.1543V72.9758M127.982 65.1543V58.044M0.982422 72.9758L0.982422 58.044" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="10" width="43" y="59" x="43" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="65.7055" x="45.622">Width: ${width}mm</tspan>

                                                </text>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 135" height="135" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M37 11.7619L113 11.7619M113 11.7619V17M113 11.7619V7M37 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <path stroke-linejoin="round" stroke-linecap="round" stroke="black" d="M75 22H102.464M75 22L93.3093 31.3684M75 22H47.5361M75 22L56.6907 31.3684M36.8557 22L1 44.25M36.8557 22L10.9175 44.25V47.319L49.0619 84.9138M36.8557 22H47.5361M1 44.25V47.319M1 44.25H149M1 44.25L26.1753 32.2131M1 47.319L75 111M1 47.319L49.0619 84.9138M1 47.319H149M75 111L149 47.319M75 111L49.0619 84.9138M75 111L100.938 84.9138M75 111L66.1763 86.4483M75 111L84.1179 86.4483M149 47.319V44.25M149 47.319L100.938 84.9138M149 44.25L113.144 22M149 44.25L123.825 32.2131M113.144 22L139.082 44.25V47.319L100.938 84.9138M113.144 22H102.464M31.5155 44.25V47.319M31.5155 44.25L56.6907 31.3684M31.5155 44.25L26.1753 32.2131M31.5155 47.319L49.0619 84.9138M31.5155 47.319L66.1763 86.4483M118.485 44.25V47.319M118.485 44.25L93.3093 31.3684M118.485 44.25L123.825 32.2131M118.485 47.319L100.938 84.9138M118.485 47.319L84.1179 86.4483M102.464 22L93.3093 31.3684M102.464 22L123.825 32.2131M93.3093 31.3684L98.6495 44.25V47.319L84.1179 86.4483M93.3093 31.3684L75 44.25M47.5361 22L56.6907 31.3684M47.5361 22L26.1753 32.2131M56.6907 31.3684L52.1134 44.25V47.319L66.1763 86.4483M56.6907 31.3684L75 44.25M75 44.25V47.319M75 47.319L66.1763 86.4483M75 47.319L84.1179 86.4483" id="Diamond-Shape"></path>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M132.762 22V111M132.762 111H127M132.762 111H138M127 22H138" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="87" x="112" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="92.8182" x="114.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="128" x="55" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="133.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 114V124M75.2857 124H69M75.2857 124H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 104.5C77.4853 104.5 79.5 106.515 79.5 109C79.5 111.485 77.4853 113.5 75 113.5C72.5147 113.5 70.5 111.485 70.5 109C70.5 106.515 72.5147 104.5 75 104.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Radiant") {

                            // do something for Radiant

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 104 130" height="130" width="104">

                                    <g id="Radiant-Plot-Diagram">

                                        <path stroke="black" d="M14.4424 2L89.8648 2.30769M14.4424 2L2 14.4615M14.4424 2L24.427 13.3846M89.8648 2.30769L102 14.4615M89.8648 2.30769L79.1121 13.3846M102 14.4615V115.231M102 14.4615L93.3979 24.1538M102 115.231L89.2504 128M102 115.231L93.3979 105.692M89.2504 128H15.6713M89.2504 128L80.0338 116.308M15.6713 128L2 114.308M15.6713 128L24.427 116.308M2 114.308V14.4615M2 114.308L10.7558 105.692M2 14.4615L10.7558 24.1538M24.427 13.3846H79.1121M24.427 13.3846L10.7558 24.1538M24.427 13.3846L52.384 20.7692M24.427 13.3846V24.1538M79.1121 13.3846L93.3979 24.1538M79.1121 13.3846L52.384 20.7692M93.3979 24.1538V105.692M93.3979 24.1538L79.1121 24.9231M93.3979 24.1538L82.0307 64.7692M93.3979 105.692L80.0338 116.308M93.3979 105.692H79.1121M93.3979 105.692L82.0307 64.7692M80.0338 116.308H24.427M80.0338 116.308L79.1121 105.692M80.0338 116.308L52.384 109.385M24.427 116.308L10.7558 105.692M24.427 116.308L52.384 109.385M24.427 116.308L25.6559 105.692M10.7558 105.692V24.1538M10.7558 105.692H25.6559M10.7558 105.692L22.5837 64.7692M10.7558 24.1538H24.427M10.7558 24.1538L22.5837 64.7692M79.1121 24.9231L52.384 20.7692M79.1121 24.9231L82.0307 64.7692M52.384 20.7692L24.427 24.1538M24.427 24.1538L22.5837 64.7692M82.0307 64.7692L79.1121 105.692M79.1121 105.692L52.384 109.385M52.384 109.385L25.6559 105.692M25.6559 105.692L22.5837 64.7692" id="Vector-Radiant-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M41.381 1V129M41.381 129H33M41.381 129H49M33 1H49" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="26.2383" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.935" x="29.2533" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M1 65.1429L103 65.1429M103 65.1429V73M103 65.1429V58M1 73L1 58" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="58.9756" x="44.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="65.6811" x="46.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 142" height="142" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M149 35.2046V38.6892M149 35.2046H125.218M149 35.2046L139.761 28.6023M149 38.6892L134.303 59.5965M149 38.6892H125.218M100.155 99.3938L116.253 85.2722L134.303 59.5965M100.155 99.3938L75.0915 117M100.155 99.3938L126.132 62.5309M75.0915 117L49.4796 99.3938M75.0915 117V105.263M49.4796 99.3938L33.9295 85.2722L15.7794 59.5965M49.4796 99.3938L24.4166 62.5309M1 38.6892V35.2046M1 38.6892L15.7794 59.5965M1 38.6892H24.4166M1 35.2046H24.4166M1 35.2046L10.513 28.6023M75.0915 78.6699L97.9592 70.2336M75.0915 78.6699V105.263M75.0915 78.6699L52.2237 70.2336M97.9592 70.2336L120.095 55.3784M97.9592 70.2336L75.0915 105.263M120.095 55.3784L126.132 62.5309M120.095 55.3784L125.218 38.6892M126.132 62.5309L134.303 59.5965M126.132 62.5309L75.0915 105.263M75.0915 105.263L24.4166 62.5309M75.0915 105.263L52.2237 70.2336M24.4166 62.5309L29.5389 55.3784M24.4166 62.5309L15.7794 59.5965M52.2237 70.2336L29.5389 55.3784M29.5389 55.3784L24.4166 38.6892M125.218 38.6892H24.4166M125.218 38.6892V35.2046M24.4166 38.6892V35.2046M24.4166 35.2046H125.218M24.4166 35.2046L27.7095 30.0695M125.218 35.2046L122.473 30.0695M139.761 28.6023L130.523 22H116.253M139.761 28.6023L122.473 30.0695M139.761 28.6023L116.253 22M122.473 30.0695H27.7095M122.473 30.0695L81.1286 22M27.7095 30.0695L10.513 28.6023M27.7095 30.0695L67.042 22M10.513 28.6023L20.026 22H30.8195M10.513 28.6023L30.8195 22M116.253 22H81.1286M30.8195 22H67.042M81.1286 22H67.042" id="Radiant-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M20 11.7619L131 11.7619M131 11.7619V17M131 11.7619V7M20 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="58" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="61.5649">Table: ${value.table}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M131.762 21V117M131.762 117H126M131.762 117H137M126 21H137" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="95" x="111" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="100.818" x="113.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="135" x="55" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="140.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 121V131M75.2857 131H69M75.2857 131H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 111.5C77.4853 111.5 79.5 113.515 79.5 116C79.5 118.485 77.4853 120.5 75 120.5C72.5147 120.5 70.5 118.485 70.5 116C70.5 113.515 72.5147 111.5 75 111.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        } else if (value.shape === "Elongated Hexagon") {

                            // do something for Elongated Hexagon

                            productHtml +=`<div class="swiper-slide diagramRoundPlot"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 68 130" height="130" width="68">

                                    <g id="Elongated-Hexagon-Plot-Diagram">

                                        <path stroke="black" d="M34.7461 2L38.6836 17.7087M34.7461 2L30.4805 17.7087M34.7461 2L39.3738 7.70472M34.7461 2L30.0455 7.70472M66 40.5276L54.6797 41.7677M66 40.5276L60.9699 34.3268M66 40.5276L57.3867 52.5157M66 40.5276V47.6378M66 90.0512L57.3867 76.4094M66 90.0512L54.5977 88.563M66 90.0512V80.874M66 90.0512L61.0293 96.0866M34.7461 128L38.6836 112.539M34.7461 128L30.5625 112.539M34.7461 128L39.4784 122.254M34.7461 128L29.9392 122.254M3 90.0512L11.8594 76.4094M3 90.0512L14.4023 88.563M3 90.0512V80.874M3 90.0512L8.04894 96.0866M3 40.5276L11.3672 52.5157M3 40.5276L14.4023 41.7677M3 40.5276L8.10935 34.3268M3 40.5276V47.6378M34.7461 26.6378L38.6836 17.7087M34.7461 26.6378L30.4805 17.7087M34.7461 26.6378L41.8008 29.7795M34.7461 26.6378L27.0352 29.7795M38.6836 17.7087L41.8008 29.7795M38.6836 17.7087L39.3738 7.70472M38.6836 17.7087L44.2027 13.6575M30.4805 17.7087L30.0455 7.70472M30.4805 17.7087L25.1405 13.6575M30.4805 17.7087L27.0352 29.7795M41.8008 29.7795L46.8047 30.1929M41.8008 29.7795L47.543 40.5276M39.3738 7.70472L44.2027 13.6575M44.2027 13.6575L46.8047 30.1929M44.2027 13.6575L49.9706 20.7677M46.8047 30.1929L49.9706 20.7677M46.8047 30.1929L55.9397 28.126M46.8047 30.1929L47.543 40.5276M49.9706 20.7677L55.9397 28.126M55.9397 28.126L54.6797 41.7677M55.9397 28.126L60.9699 34.3268M54.6797 41.7677L47.543 40.5276M54.6797 41.7677L60.9699 34.3268M54.6797 41.7677L49.9706 50.9449M47.543 40.5276C48.4088 43.8898 50.1064 50.6803 49.9706 50.9449M57.3867 52.5157L49.9706 50.9449M57.3867 52.5157L51.1523 60.122M57.3867 52.5157L66 47.6378M57.3867 52.5157L66 54.748M49.9706 50.9449L51.1523 60.122M30.0455 7.70472L25.1405 13.6575M25.1405 13.6575L19.2818 20.7677M25.1405 13.6575L22.1133 30.1929M27.0352 29.7795L22.1133 30.1929M27.0352 29.7795L21.457 40.5276M22.1133 30.1929L21.457 40.5276M22.1133 30.1929L13.2187 28.126M22.1133 30.1929L19.2818 20.7677M21.457 40.5276L18.9961 50.9449M21.457 40.5276L14.4023 41.7677M18.9961 50.9449L11.3672 52.5157M18.9961 50.9449L14.4023 41.7677M18.9961 50.9449L17.7656 60.122M11.3672 52.5157L17.7656 60.122M11.3672 52.5157L3 54.748M11.3672 52.5157L3 47.6378M14.4023 41.7677L8.10935 34.3268M14.4023 41.7677L13.2187 28.126M8.10935 34.3268L13.2187 28.126M13.2187 28.126L19.2818 20.7677M51.1523 60.122L56.2383 63.6772M51.1523 60.122V69.2992M56.2383 63.6772L51.1523 69.2992M56.2383 63.6772L66 54.748M56.2383 63.6772L66 71.6968M56.2383 63.6772L66 62.8504M51.1523 69.2992L57.3867 76.4094M51.1523 69.2992L49.9706 78.063M57.3867 76.4094L49.9706 78.063M57.3867 76.4094L66 71.6968M57.3867 76.4094L66 80.874M49.9706 78.063L54.5977 88.563M49.9706 78.063L47.3789 90.0512M54.5977 88.563L47.3789 90.0512M54.5977 88.563L56.0587 102.122M54.5977 88.563L61.0293 96.0866M47.3789 90.0512L41.8008 100.634M47.3789 90.0512L46.8867 100.22M17.7656 60.122V69.2992M17.7656 60.122L12.7617 63.6772M17.7656 69.2992L19.3242 78.063M17.7656 69.2992L11.8594 76.4094M17.7656 69.2992L12.7617 63.6772M19.3242 78.063L21.457 90.0512M19.3242 78.063L14.4023 88.563M19.3242 78.063L11.8594 76.4094M21.457 90.0512L14.4023 88.563M21.457 90.0512L27.1172 100.634M21.457 90.0512L22.1953 100.22M14.4023 88.563L13.0979 102.122M14.4023 88.563L8.04894 96.0866M11.8594 76.4094L3 71.6968M11.8594 76.4094L3 80.874M12.7617 63.6772L3 54.748M12.7617 63.6772L3 71.6968M12.7617 63.6772L3 62.8504M3 54.748V47.6378M3 54.748V62.8504M3 71.6968V80.874M3 71.6968V62.8504M66 47.6378V54.748M66 54.748V62.8504M66 71.6968V80.874M66 71.6968V62.8504M38.6836 112.539L34.7461 103.61M38.6836 112.539L41.8008 100.634M38.6836 112.539L44.2108 116.508M38.6836 112.539L39.4784 122.254M34.7461 103.61L30.5625 112.539M34.7461 103.61L27.1172 100.634M34.7461 103.61L41.8008 100.634M30.5625 112.539L29.9392 122.254M30.5625 112.539L25.1324 116.508M30.5625 112.539L27.1172 100.634M27.1172 100.634L22.1953 100.22M41.8008 100.634L46.8867 100.22M46.8867 100.22L44.2108 116.508M46.8867 100.22L49.9706 109.514M46.8867 100.22L56.0587 102.122M44.2108 116.508L49.9706 109.514M44.2108 116.508L39.4784 122.254M49.9706 109.514L56.0587 102.122M56.0587 102.122L61.0293 96.0866M29.9392 122.254L25.1324 116.508M25.1324 116.508L22.1953 100.22M25.1324 116.508L19.1151 109.315M22.1953 100.22L13.0979 102.122M22.1953 100.22L19.1151 109.315M13.0979 102.122L8.04894 96.0866M13.0979 102.122L19.1151 109.315" id="Vector-Elongated-Hexagon-Shape"></path>

                                        <g id="Container-Length">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M21.381 1V129M21.381 129H13M21.381 129H29M13 1H29" id="Handle-Length"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="45" y="84.4756" x="6.23828" id="Length-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="90.9349" x="9.25329" id="Length-Value">Length: ${length}mm</text>

                                        </g>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M2 45.1429L67 45.1429M67 45.1429V53M67 45.1429V38M2 53L2 38" id="Handle-Width"></path>

                                            <rect fill="#F8F8F8" rx="2" height="10" width="43" y="38.9756" x="21.0176" id="Width-Rectangle"></rect>

                                            <text font-weight="bold" font-size="5" fill="#565656" y="45.681" x="23.6395" id="Width-Value">Width: ${width}mm</text>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                            productHtml +=`<div class="swiper-slide diagramRoundProp">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 145" height="145" width="150">

                                    <g id="Container-Proportion-Diagram">

                                        <path stroke="black" d="M132.178 30.5519L140.589 39.4505M132.178 30.5519H126.661M132.178 30.5519L125.311 26.2759M149 48.3491V53.1258M149 48.3491L140.589 39.4505M149 48.3491H140.28M149 53.1258L135.072 69.7288M149 53.1258L142.441 58.5574M149 53.1258H140.28M1 53.1258V48.3491M1 53.1258L14.928 69.7288M1 53.1258L7.52033 58.5574M1 53.1258H9.75808M1 48.3491L9.41084 39.4505M1 48.3491H9.75808M17.8217 30.5519L9.41084 39.4505M17.8217 30.5519H23.3389M17.8217 30.5519L24.7278 26.2759M75 30.5519V48.3491M75 30.5519H28.8561M75 30.5519H121.144M75 30.5519L97.9948 26.2759M75 30.5519L51.8509 26.2759M75 48.3491H18.5162M75 48.3491H131.561M75 53.1258V86.3318M75 53.1258H131.561M75 53.1258H9.75808M75 86.3318L89.8926 82.7107M75 86.3318L78.8968 100.37M75 86.3318L71.2319 100.37M75 86.3318L60.2231 82.7107M82.7935 114.407L121.144 86.3318L135.072 69.7288M82.7935 114.407L78.8968 100.37M82.7935 114.407L93.5279 97.1684M82.7935 114.407L104.785 90.5538M82.7935 114.407L129.902 66.893M82.7935 114.407L135.882 63.989M82.7935 114.407L135.072 69.7288M82.7935 114.407L78.9739 117.204M67.4639 114.407L28.8561 86.3318L14.928 69.7288M67.4639 114.407L71.2319 100.37M67.4639 114.407L56.4551 96.7485M67.4639 114.407L47.2211 92.033M67.4639 114.407L21.4484 67.5508M67.4639 114.407L14.928 69.7288M67.4639 114.407L38.8102 87.3654M67.4639 114.407L71.3091 117.204M135.882 63.989L129.902 66.893M135.882 63.989L142.441 58.5574M135.882 63.989L133.876 58.5574M104.785 79.0896L93.7894 96.7485M104.785 79.0896L89.8926 82.7107M104.785 79.0896L112.808 75.1939M45.4463 79.0896L60.2231 82.7107M45.4463 79.0896L56.4551 96.7485M45.4463 79.0896L37.3441 75.1939M14.0407 63.989L21.4484 67.5508M14.0407 63.989L38.8102 87.3654M14.0407 63.989L7.52033 58.5574M14.0407 63.989L16.4327 58.5574M93.7894 96.7485L89.8926 82.7107M93.7894 96.7485L93.5279 97.1684M89.8926 82.7107L78.8968 100.37M78.8968 100.37L71.3091 117.204M71.2319 100.37L60.2231 82.7107M71.2319 100.37L78.9739 117.204M60.2231 82.7107L56.4551 96.7485M56.4551 96.7485L37.3441 75.1939M37.3441 75.1939L28.8561 71.1126M37.3441 75.1939L47.2211 92.033M47.2211 92.033L28.8561 71.1126M47.2211 92.033L21.4484 67.5508M28.8561 71.1126L21.4484 67.5508M28.8561 71.1126L18.5162 52.5865L16.4327 58.5574M123.922 69.7969L112.808 75.1939M123.922 69.7969L104.785 90.5538M123.922 69.7969L129.902 66.893M123.922 69.7969L127.572 61.8318M93.5279 97.1684L112.808 75.1939M112.808 75.1939L104.785 90.5538M104.785 90.5538L129.902 66.893M129.902 66.893L127.572 61.8318M129.902 66.893L133.876 58.5574M21.4484 67.5508L38.8102 87.3654M21.4484 67.5508L23.3389 61.8318L16.4327 58.5574M21.4484 67.5508L16.4327 58.5574M140.589 39.4505H9.41084M28.8561 30.5519L18.5162 48.3491M28.8561 30.5519H23.3389M28.8561 30.5519L31.5568 26.2759M28.8561 30.5519L51.8509 26.2759M18.5162 48.3491H9.75808M23.3389 30.5519L9.75808 48.3491M23.3389 30.5519L24.7278 26.2759M23.3389 30.5519L31.5568 26.2759M34.2576 22H31.634L24.7278 26.2759M34.2576 22L31.5568 26.2759M34.2576 22H54.5516M115.434 22H118.443L125.311 26.2759M115.434 22L118.289 26.2759M115.434 22H95.1397M121.144 30.5519L131.561 48.3491M121.144 30.5519H126.661M121.144 30.5519L118.289 26.2759M121.144 30.5519L97.9948 26.2759M131.561 48.3491H140.28M126.661 30.5519L140.28 48.3491M126.661 30.5519L125.311 26.2759M126.661 30.5519L118.289 26.2759M74.8457 22H54.5516M74.8457 22H95.1397M74.8457 22L97.9948 26.2759M74.8457 22L51.8509 26.2759M24.7278 26.2759H31.5568M125.311 26.2759H118.289M118.289 26.2759L95.1397 22M118.289 26.2759H97.9948M31.5568 26.2759L54.5516 22M31.5568 26.2759H51.8509M54.5516 22L51.8509 26.2759M51.8509 26.2759H97.9948M95.1397 22L97.9948 26.2759M142.441 58.5574L140.28 53.1258M142.441 58.5574H133.876M140.28 53.1258L133.876 58.5574M140.28 53.1258H131.561M133.876 58.5574L131.561 53.1258M133.876 58.5574L127.572 61.8318M131.561 53.1258L127.572 61.8318M7.52033 58.5574L9.75808 53.1258M7.52033 58.5574H16.4327M9.75808 53.1258L16.4327 58.5574M78.9739 117.204L75.1543 120L71.3091 117.204" id="Elongated-Hexagon-Shape"></path>

                                        <g id="Container-Width">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M31 11.7619L118 11.7619M118 11.7619V17M118 11.7619V7M31 17V7" id="Handle-Width"></path>

                                            <g id="Container-Width-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="35" x="57" id="Width-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Width-Value">

                                                    <tspan y="5.81818" x="60.5649">Table: ${value.length}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Depth">

                                            <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M131.762 22V120M131.762 120H126M131.762 120H137M126 22H137" id="Handle-Depth"></path>

                                            <g id="Container-Depth-Text">

                                                <rect fill="#F8F8F8" rx="2" height="8" width="36" y="102" x="111" id="Depth-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Depth-Value">

                                                    <tspan y="107.818" x="113.684">Depth: ${value.depth}%</tspan>

                                                </text>

                                            </g>

                                        </g>

                                        <g id="Container-Culet">

                                            <g id="Container-Culet-Text">

                                                <rect fill="#F8F8F8" rx="2" height="7" width="39" y="138" x="56" id="Culet-Rectangle"></rect>

                                                <text letter-spacing="0em" font-weight="bold" font-size="5" font-family="Inter" style="white-space: pre" xml:space="preserve" fill="#565656" id="Culet-Value">

                                                    <tspan y="143.818" x="57">Culet: ${value.culet ? value.culet : 'None'}</tspan>

                                                </text>

                                            </g>

                                            <g id="Container-Culet-Handle">

                                                <path stroke-linejoin="round" stroke-linecap="round" stroke="#565656" d="M75.2857 124V134M75.2857 134H69M75.2857 134H81" id="Handle-Culet-Line"></path>

                                                <path stroke="#565656" d="M75 114.5C77.4853 114.5 79.5 116.515 79.5 119C79.5 121.485 77.4853 123.5 75 123.5C72.5147 123.5 70.5 121.485 70.5 119C70.5 116.515 72.5147 114.5 75 114.5Z" id="Handle-Culet-Circle"></path>

                                            </g>

                                        </g>

                                    </g>

                                </svg>

                            </div>`;

                        }



                        // hand-with-carat-slider tile removed



                    productHtml +='</div>'

                    + '<!-- Pagination for mobile -->'

                    + '<div class="swiper-pagination"></div>'

                + '</div>'

            + '</div>'

            + '<div class="grid__item product-single__information medium-up--one-third product-single__description-container">'

                + '<div class="product-single__meta">'

                    + '<h1 class="product-single__title sp-dd-title" role="heading" aria-level="2" data-uw-rm-heading="level">'+value.title+'</h1>'

                    + '<div class="product-single__sku">Certificate Number#:'

                        + '<span>'+value.cert_num+'</span>'

                    + '</div>'

                    + '<div class="product-single__price">'

                        + '<div class="prodcut__price">';

                            if(value.sale_price){

                              productHtml +='<div class="price__on-sale" data-uw-rm-sr="">'+theme.Currency.formatMoney( Currency.convert(value.sale_price * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+'</div>';

                              productHtml +='<div class="price__regular" data-uw-rm-sr="price" aria-label="Previous price was '+theme.Currency.formatMoney( Currency.convert(value.original_price * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+'">'+theme.Currency.formatMoney( Currency.convert(value.original_price * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+'</div>';

                              productHtml +='<div class="precentage_off" data-uw-rm-sr="">('+theme.Currency.formatMoney( Currency.convert( (value.original_price - value.sale_price) * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+' OFF)</div>';

                            }

                            if( (value.sale_price==0 || value.sale_price=='' ) && value.original_price!='' ){

                              productHtml +='<div class="price__on-sale" data-uw-rm-sr="">'+theme.Currency.formatMoney( Currency.convert(value.original_price * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+'</div>';

                            }

                            productHtml +='<div class="diamond__only">(Diamond Only)</div>'

                        + '</div>'

                        + '<!--<div class="bank-wire-price" data-uw-rm-sr="">BANK WIRE PRICE $359</div>-->'

                    + '</div>'

                    + '<!--<div class="affirm-info-wrapper">'

                        + '<p class="affirm-as-low-as" >Starting at <span class="affirm-ala-price" data-uw-rm-sr="">$34</span>/mo or 0% APR with <span class="__affirm-logo __affirm-logo-blue __ligature__affirm_full_logo__ __processed">Affirm</span>. <a class="affirm-modal-trigger" aria-label="See if you qualify - Learn more about Affirm Financing (opens in modal)"'

                            + 'href="javascript:void(0)">See if you qualify</a>'

                        + '</p>'

                    + '</div>-->'

                    + '<div class="product__addon-info">'

                        + '<p class="extented-returns-popup-button">Free Insured Shipping. <span class="extented-returns-title">30 Day Returns.</span></p>'

                    + '</div>'

                    + '<div class="diamond-short-information">'

                        + '<div class="diamond-info-wrapper">'

                            + '<div class="diamond-info">Shape:'

                                + '<span class="shape-info">'+value.shape+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Color:'

                                + '<span class="color-info">'+value.color+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Carat:'

                                + '<span class="carat-info">'+value.carat+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Clarity:'

                                + '<span class="clarity-info">'+value.clarity+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Cut:'

                                + '<span class="cut-info">'+value.cut+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Certificate:'

                                + '<span class="certificate-type-info">'+value.lab+'</span>'

                            + '</div>'

                        + '</div>'

                        + '<div class="diamond-more-info">'

                            + '<p class="more-info-button">MORE DETAILS</p>'

                        + '</div>'

                    + '</div>'

                    + '<div class="purchase-advantage diamond-pdp-advantage hide">'

                        + '<span class="free-return-info">'

                        + '<span></span>30 - day Return Period</span> <span class="free-shipping-info">'

                        + '<span></span>Free Shipping</span>'

                    + '</div>'

                    + ''

                    + '<form method="post" action="/cart/add" id="product_form_8281019023643" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form="">'

                        + '<input type="hidden" name="form_type" value="product">'

                        + '<input type="hidden" name="utf8" value="?">'

                        + '<div class="product-form__controls-group product-form__controls-group--submit">'

                            + '<div class="product-form__item product-form__item--submit">'

                                + '<div class="product-form__add-to-setting">'

                                    + '<div class="ship-timeline-n-tracking">'

                                        + '<p class="product-form_ship-in-ring-timeline ship-msg">Ships in a ring by'

                                            + '<b>'+shipInDate.toString('ddd, MMMM d')+'</b>'

                                        + '</p>'

                                        + '<p class="realtime-track">Track in real time before it ships</p>'

                                    + '</div>'

                                    + '<div class="sticky-button-price-wrapper ">'

                                        /* 2026-05-22: removed `.product-sticky-price` mini-price block -
                                           duplicated the hero price inline and on the sticky bar. */

                                        + '<button type="button" name="add" id="addtoring" data-product="'+_diamondFor+'" data-sku="'+value.sku+'" class="btn"><span class="rsloading-spinner" data-loader=""></span><span id="btntxtcart" data-add-to-cart-text="">'+_btnTxt+'</span></button>'

                                    + '</div>'

                                + '</div>'

                                + '<div class="product-form__buy-loose">'

                                    + '<p class="product-form_ship-loose-timeline ship-msg">'

                                        + 'Ships Loose By'

                                        + '<b>'+shipByDate.toString('ddd, MMMM d')+'</b>'

                                    + '</p>'

                                    + '<input type="hidden" name="properties[SKU]"        value="'+(value.sku||'')+'">'

                                    + '<input type="hidden" name="properties[SHAPE]"      value="'+(value.shape||'')+'">'

                                    + '<input type="hidden" name="properties[COLOR]"      value="'+(value.color||'')+'">'

                                    + '<input type="hidden" name="properties[CLARITY]"    value="'+(value.clarity||'')+'">'

                                    + '<input type="hidden" name="properties[LAB]"        value="'+(value.lab||'')+'">'

                                    + '<input type="hidden" name="properties[CERT #]"     value="'+(value.cert_num||'')+'">'

                                    + '<input type="hidden" name="properties[DIMENSION]"  value="'+(value.measurement||'')+'">'

                                    + (value.box_number ? '<input type="hidden" name="properties[_box_number]" value="'+value.box_number+'">' : '')

                                    + '<input type="hidden" name="properties[Ship by]"    value="'+shipByDate.toString('ddd, MMMM d')+'">'

                                    + '<input type="hidden" name="product-id" id="productid" value="">'

                                    + '<input type="hidden" name="id" id="mainvid" value="">'

                                    + '<input type="hidden" name="section-id" value="template--15762090885181__main">'

                                    + '<button type="button" name="add" aria-label="Add to cart" id="createproduct" class="btn btn--secondary-accent">'

                                        + '<span class="rsloading-spinner" data-loader=""></span>'

                                        + '<span data-add-to-cart-text="">Buy Loose</span>'

                                    + '</button>'

                                + '</div>'

                            + '</div>'

                        + '</div>'

                        + '<input type="hidden" name="product-id" value="">'

                        + '<input type="hidden" name="section-id" value="diamond-product-template">'

                    + '</form>'

                    + '<h2 class="product_description--h2">Product Information</h2>'

                    + '<div class="product_description--accordion">'

                        + '<div class="accordion-header">'

                            + '<h3 class="ac-h3">DIAMOND DETAILS</h3>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content" style="display: none;">'

                            + '<div class="pair-first-diamond">'

                                + '<p>'

                                    + '<span class="meta__title">Lab</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                          + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl(value)+'" rel="null noopener" aria-describedby="a11y-new-window-message" aria-label="GIA - open in a new tab" data-uw-rm-ext-link="" uw-rm-external-link-id="'+_spCertUrl(value)+'" data-uw-rm-brl="PR" data-uw-original-href="'+_spCertUrl(value)+'">'

                                          + '<span class="lab-name">'+value.lab+'</span>'

                                          + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Certificate Number</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                        + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl(value)+'" rel="null noopener" aria-describedby="a11y-new-window-message" aria-label="'+value.cert_num+' - open in a new tab" data-uw-rm-ext-link="" uw-rm-external-link-id="'+_spCertUrl(value)+'" data-uw-rm-brl="PR" data-uw-original-href="'+_spCertUrl(value)+'">'

                                          + '<span class="certificate-number">'+value.cert_num+'</span>'

                                        + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">SHAPE</span>'

                                    + '<span class="meta-info-desc shape-info">'+value.shape+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">CARAT</span>'

                                    + '<span class="meta-info-desc carat-info">'+value.carat+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Cut</span>'

                                    + '<span class="meta-info-desc cut-info">'+value.cut+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Color</span>'

                                    + '<span class="meta-info-desc color-info">'+value.color+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Clarity</span>'

                                    + '<span class="meta-info-desc clarity-info">'+value.clarity+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Polish</span>'

                                    + '<span class="meta-info-desc polish-info">'+value.polish+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Symmetry</span>'

                                    + '<span class="meta-info-desc symmetry-info">'+value.symmetry+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Fluorescence</span>'

                                    + '<span class="meta-info-desc fluorescence-info">'+value.fluorescence+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">TABLE</span>'

                                    + '<span class="meta-info-desc table-info">'+value.table+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">DEPTH</span>'

                                    + '<span class="meta-info-desc depth-info">'+value.depth+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">MEASUREMENT</span>'

                                    + '<span class="meta-info-desc measurements-info">'+value.measurement+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">L/W RATIO</span>'

                                    + '<span class="meta-info-desc l-w-ratio-info">'+value.lw_ratio+'</span>'

                                + '</p>'

                            + '</div>'

                        + '</div>'

                        + '<div class="accordion-header price-match-guarantee" style="display: none;">'

                            + '<h3 class="ac-h3">DIAMOND PRICE GUARANTEE</h3>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content">'

                            + '<p class="learn--more">Our large inventory of exclusive diamonds is fair priced! Therefore, if you find the same diamond with a matching GIA or IGI certificate, we will honor the price.'

                                + '<span>'

                                  + '<a href="#" data-uw-rm-brl="PR" data-uw-original-href="#"  >Learn more.</a>'

                                + '</span>'

                            + '</p>'

                        + '</div>'

                        + '<div class="accordion-header lifetime-diamond-upgrade">'

                            + '<h3 class="ac-h3">LIFETIME DIAMOND UPGRADE</h4>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content">'

                            + '<p>'+_diamondUpdate+'</p>'

                        + '</div>'

                    + '</div>'

                + '</div>'

            + '</div>';

          }else{



              var productHtml = '<div class="grid__item product-single__diamond-group medium-up--two-thirds" data-product-single-media-group="">'

                + '<div class="diamond-image-wrapper">'

                    + '<div class="diamond-image">'

                        + '<div class="diamondimg diamond-image-grid">'

                            + '<div class="image-wrapper">';

                                if( value.cover_pic.indexOf("http") == 0 ){

                                    productHtml +='<img src="'+value.cover_pic+'" alt="'+value.title+'">';

                                }else{

                                    productHtml +='<img src="'+theme.settings.assetUrl+value.cover_pic+'" alt="'+value.title+'">';

                                }

                             productHtml +='</div>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-iframe">'

                        + '<div class="diamond-image-grid">'

                            + '<iframe width="600px" height="600px" data-uw-rm-iframe="un"></iframe>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-fingure-view">'

                        + '<div class="diamond-image-grid">'

                            + '<div class="image-wrapper">'

                                + '<img alt="Loose Diamond" class="thubnil-img lazyloaded" src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/loose-diamond-hand-large_1.webp?v=1716216116">'

                            + '</div>'

                            + '<div class="diamond-on-hand">'

                                + '<span class="hand_diamond_img oval" style="background-size: 41.85%;background-image: url('+theme.settings.assetUrl+value.raw_diamond+');"></span>'

                            + '</div>'

                            + '<div id="slider" class="ui-slider ui-corner-all ui-slider-horizontal ui-widget ui-widget-content">'

                                + '<div id="custom-handle" class="ui-slider-handle ui-corner-all ui-state-default" tabindex="0" style="left: 2.93103%;"><span>0.37 Ct</span></div>'

                            + '</div>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-certificate">'

                        + '<div class="diamond-image-grid">'

                            + '<div class="image-wrapper">'

                                + '<img alt="IGI Certified" class="thubnil-img lazyloaded"  src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">'

                            + '</div>'

                        + '</div>'

                    + '</div>'

                + '</div>'

                + '<div class="diamond-thumbnil-wrapper">'

                    + '<div class="diamond-thumbnil diamond-image active" data-type="diamond-image">';

                        if( value.cover_pic.indexOf("http") == 0 ){

                              productHtml +='<img src="'+value.cover_pic+'" alt="'+value.title+'">';

                          }else{

                              productHtml +='<img src="'+theme.settings.assetUrl+value.cover_pic+'" alt="'+value.title+'">';

                          }

                    productHtml +='</div>';

                    if( value.workshop_preview_url ){

                    productHtml +='<div class="diamond-thumbnil diamond-360" data-frame="'+value.workshop_preview_url+'" data-type="diamond-iframe">'

                        + '<img alt="Diamond Video" class="thubnil-img ls-is-cached lazyloaded"  src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/video_play.png?v=1716214635" >'

                    + '</div>';

                    }

                  if( value.raw_diamond ){

                    productHtml +='<div class="diamond-thumbnil diamond-size-preivew" data-carat="'+value.carat+'" data-type="diamond-fingure-view">'

                        + '<img alt="Loose Diamond" class="thubnil-img ls-is-cached lazyloaded" src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/loose-diamond-hand.webp?v=1716214787">'

                        + '<div class="diamond-on-hand">'

                            + '<span class="hand_diamond_img round oval" style="background-size: 41.85%;background-image: url('+theme.settings.assetUrl+value.raw_diamond+');"></span>'

                        + '</div>'

                    + '</div>';

                  }

                    productHtml +='<div class="diamond-thumbnil diamond-certificate" data-type="diamond-certificate">'

                        + '<a href="'+_spCertUrl(value)+'" target="_blank" rel="null noopener" aria-describedby="a11y-new-window-message" data-uw-original-href="'+_spCertUrl(value)+'">';

                        if(value.lab=='GIA'){

                            productHtml +='<img alt="GIA Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/GIA-Logo.jpg?v=1744102867">';

                        }else{

                          productHtml +='<img alt="IGI Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">'

                        }

                        productHtml +='</a>'

                    + '</div>'

                + '</div>'

                + '<div class="diamond-thumbnil-wrapper" style="margin-top:10px;">'

                    + '<div class="diamond-thumbnil diamond-image active" data-type="diamond-image">';

                        if( value.cover_pic_two.indexOf("http") == 0 ){

                              productHtml +='<img src="'+theme.settings.assetUrl+value.cover_pic_two+'" alt="'+value.title+'">';

                          }else{

                              productHtml +='<img src="'+value.cover_pic_two+'" alt="'+value.title+'">';

                          }

                    productHtml +='</div>';

                    if( value.workshop_preview_url_two ){

                        productHtml +='<div class="diamond-thumbnil diamond-360" data-frame="'+value.workshop_preview_url_two+'" data-type="diamond-iframe">'

                            + '<img alt="Diamond Video" class="thubnil-img ls-is-cached lazyloaded"  src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/video_play.png?v=1716214635" >'

                        + '</div>';

                    }

                    if( value.raw_diamond_two ){

                        productHtml +='<div class="diamond-thumbnil diamond-size-preivew" data-carat="'+value.carat_two+'" data-type="diamond-fingure-view">'

                            + '<img alt="Loose Diamond" class="thubnil-img ls-is-cached lazyloaded" src="https://cdn.shopify.com/s/files/1/0599/0839/0973/files/loose-diamond-hand.webp?v=1716214787">'

                            + '<div class="diamond-on-hand">'

                                + '<span class="hand_diamond_img round oval" style="background-size: 41.85%;background-image: url('+theme.settings.assetUrl+value.raw_diamond_two+');"></span>'

                            + '</div>'

                        + '</div>';

                    }

                    productHtml +='<div class="diamond-thumbnil diamond-certificate" data-type="diamond-certificate">'

                        + '<a href="'+_spCertUrl({lab_url:value.lab_url_two,lab:value.lab_two,cert_num:value.cert_num_two})+'" target="_blank" rel="null noopener" aria-describedby="a11y-new-window-message" data-uw-original-href="'+_spCertUrl({lab_url:value.lab_url_two,lab:value.lab_two,cert_num:value.cert_num_two})+'">';

                        if(value.lab=='GIA'){

                            productHtml +='<img alt="GIA Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/GIA-Logo.jpg?v=1744102867">';

                        }else{

                          productHtml +='<img alt="IGI Certified" src="https://cdn.shopify.com/s/files/1/0708/5876/8690/files/igi_logo_Logo.jpg?v=1720891382">'

                        }

                        productHtml +='</a>'

                    + '</div>'

                + '</div>'

            + '</div>'

            + '<div class="grid__item product-single__information medium-up--one-third product-single__description-container">'

                + '<div class="product-single__meta">'

                    + '<h1 class="product-single__title sp-dd-title" role="heading" aria-level="2" data-uw-rm-heading="level">'+value.title+'</h1>'

                    + '<div class="product-single__sku">Certificate Number#:'

                        + '<span>'+value.cert_num+'</span>'

                    + '</div>'

                    + '<div class="product-single__price">'

                        + '<div class="prodcut__price">';

                            productHtml +='<div class="price__on-sale" data-uw-rm-sr="">'+theme.Currency.formatMoney( Currency.convert(value.final_price * 100, 'USD' , theme.settings.shopCurrency) , theme.settings.moneyFormat)+'</div>';

                            productHtml +='<div class="diamond__only">(Diamond Only)</div>'

                        + '</div>'

                        + '<!--<div class="bank-wire-price" data-uw-rm-sr="">BANK WIRE PRICE $359</div>-->'

                    + '</div>'

                    + '<!--<div class="affirm-info-wrapper">'

                        + '<p class="affirm-as-low-as" >Starting at <span class="affirm-ala-price" data-uw-rm-sr="">$34</span>/mo or 0% APR with <span class="__affirm-logo __affirm-logo-blue __ligature__affirm_full_logo__ __processed">Affirm</span>. <a class="affirm-modal-trigger" aria-label="See if you qualify - Learn more about Affirm Financing (opens in modal)"'

                            + 'href="javascript:void(0)">See if you qualify</a>'

                        + '</p>'

                    + '</div>-->'

                    + '<div class="product__addon-info">'

                        + '<p class="extented-returns-popup-button">Free Insured Shipping. <span class="extented-returns-title">30 Day Returns.</span></p>'

                    + '</div>'

                    + '<div class="diamond-short-information">'

                        + '<p class="">Diamond Details 1</p>'

                        + '<div class="diamond-info-wrapper">'

                            + '<div class="diamond-info">Shape:'

                                + '<span class="shape-info">'+value.shape+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Color:'

                                + '<span class="color-info">'+value.color+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Carat:'

                                + '<span class="carat-info">'+value.carat+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Clarity:'

                                + '<span class="clarity-info">'+value.clarity+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Cut:'

                                + '<span class="cut-info">'+value.cut+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Certificate:'

                                + '<span class="certificate-type-info">'+value.lab+'</span>'

                            + '</div>'

                        + '</div>'

                        + '<div class="diamond-more-info">'

                            + '<p class="more-info-button">MORE DETAILS</p>'

                        + '</div>'

                    + '</div>'

                    + '<div class="diamond-short-information">'

                        + '<p class="">Diamond Details 2</p>'

                        + '<div class="diamond-info-wrapper">'

                            + '<div class="diamond-info">Shape:'

                                + '<span class="shape-info">'+value.shape_two+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Color:'

                                + '<span class="color-info">'+value.color_two+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Carat:'

                                + '<span class="carat-info">'+value.carat_two+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Clarity:'

                                + '<span class="clarity-info">'+value.clarity_two+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Cut:'

                                + '<span class="cut-info">'+value.cut_two+'</span>'

                            + '</div>'

                            + '<div class="diamond-info">Certificate:'

                                + '<span class="certificate-type-info">'+value.lab_two+'</span>'

                            + '</div>'

                        + '</div>'

                        + '<div class="diamond-more-info">'

                            + '<p class="more-info-button">MORE DETAILS</p>'

                        + '</div>'

                    + '</div>'

                    + '<div class="purchase-advantage diamond-pdp-advantage hide">'

                        + '<span class="free-return-info">'

                        + '<span></span>30 - day Return Period</span> <span class="free-shipping-info">'

                        + '<span></span>Free Shipping</span>'

                    + '</div>'

                    + ''

                    + '<form method="post" action="/cart/add" id="product_form_8281019023643" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form="">'

                        + '<input type="hidden" name="form_type" value="product">'

                        + '<input type="hidden" name="utf8" value="?">'

                        + '<div class="product-form__controls-group product-form__controls-group--submit">'

                            + '<div class="product-form__item product-form__item--submit">'

                                + '<div class="product-form__add-to-setting">'

                                    + '<div class="ship-timeline-n-tracking">'

                                        + '<p class="product-form_ship-in-ring-timeline ship-msg">Ships in a ring by'

                                            + '<b>'+shipInDate.toString('ddd, MMMM d')+'</b>'

                                        + '</p>'

                                        + '<p class="realtime-track">Track in real time before it ships</p>'

                                    + '</div>'

                                    + '<div class="sticky-button-price-wrapper ">'

                                        /* 2026-05-22: removed `.product-sticky-price` mini-price block -
                                           same change as the engagement-ring path above; this is the
                                           Earring code path. */

                                        + '<button type="button" name="add" id="addtoring" data-product="Earring" data-sku="'+value.sku+'" class="btn"><span class="rsloading-spinner" data-loader=""></span><span id="btntxtcart" data-add-to-cart-text="">'+_btnTxt+'</span></button>'

                                    + '</div>'

                                + '</div>'

                                + '<div class="product-form__buy-loose">'

                                    + '<p class="product-form_ship-loose-timeline ship-msg">'

                                        + 'Ships Loose By'

                                        + '<b>'+shipByDate.toString('ddd, MMMM d')+'</b>'

                                    + '</p>'

                                    + '<input type="hidden" name="properties[COLOR]" id="properties-color" value="'+value.color+'">'

                                    + '<input type="hidden" name="properties[CLARITY]" id="properties-clarity" value="'+value.clarity+'">'

                                    + '<input type="hidden" name="properties[LAB]" id="properties-lab" value="'+value.lab+'">'

                                    + '<input type="hidden" name="properties[Ship by]" id="properties-ship-by" value="'+shipByDate.toString('ddd, MMMM d')+'">'

                                    + (value.box_number ? '<input type="hidden" name="properties[_box_number]" value="'+value.box_number+'">' : '')

                                    + '<input type="hidden" name="product-id" id="productid" value="">'

                                    + '<input type="hidden" name="id" id="mainvid" value="">'

                                    + '<input type="hidden" name="section-id" value="template--15762090885181__main">'

                                    + '<button type="button" name="add" aria-label="Add to cart" id="createproduct" class="btn btn--secondary-accent">'

                                        + '<span class="rsloading-spinner" data-loader=""></span>'

                                        + '<span data-add-to-cart-text="">Buy Loose</span>'

                                    + '</button>'

                                + '</div>'

                            + '</div>'

                        + '</div>'

                        + '<input type="hidden" name="product-id" value="">'

                        + '<input type="hidden" name="section-id" value="diamond-product-template">'

                    + '</form>'

                    + '<div class="product_description--accordion">'

                        + '<div class="accordion-header active">'

                            + '<h4>DIAMOND DETAILS</h4>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content" style="display: block;">'

                            + '<p class="diamond-details-title">Diamond 1 details</p>'

                            + '<div class="pair-first-diamond">'

                                + '<p>'

                                    + '<span class="meta__title">Lab</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                          + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl(value)+'" rel="null noopener"  >'

                                          + '<span class="lab-name">'+value.lab+'</span>'

                                          + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Certificate Number</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                        + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl(value)+'" rel="null noopener" >'

                                          + '<span class="certificate-number">'+value.cert_num+'</span>'

                                        + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">SHAPE</span>'

                                    + '<span class="meta-info-desc shape-info">'+value.shape+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">CARAT</span>'

                                    + '<span class="meta-info-desc carat-info">'+value.carat+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Cut</span>'

                                    + '<span class="meta-info-desc cut-info">'+value.cut+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Color</span>'

                                    + '<span class="meta-info-desc color-info">'+value.color+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Clarity</span>'

                                    + '<span class="meta-info-desc clarity-info">'+value.clarity+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Polish</span>'

                                    + '<span class="meta-info-desc polish-info">'+value.polish+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Symmetry</span>'

                                    + '<span class="meta-info-desc symmetry-info">'+value.symmetry+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Fluorescence</span>'

                                    + '<span class="meta-info-desc fluorescence-info">'+value.fluorescence+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">TABLE</span>'

                                    + '<span class="meta-info-desc table-info">'+value.table+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">DEPTH</span>'

                                    + '<span class="meta-info-desc depth-info">'+value.depth+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">MEASUREMENT</span>'

                                    + '<span class="meta-info-desc measurements-info">'+value.measurement+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">L/W RATIO</span>'

                                    + '<span class="meta-info-desc l-w-ratio-info">'+value.lw_ratio+'</span>'

                                + '</p>'

                            + '</div>'

                              + '<p class="diamond-details-title">Diamond 2 details</p>'

                            + '<div class="pair-first-diamond">'

                                + '<p>'

                                    + '<span class="meta__title">Lab</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                          + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl({lab_url:value.lab_url_two,lab:value.lab_two,cert_num:value.cert_num_two})+'" rel="null noopener"  >'

                                          + '<span class="lab-name">'+value.lab_two+'</span>'

                                          + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Certificate Number</span>'

                                    + '<span class="meta-info-desc metal-variant-info">'

                                        + '<a class="diamond-certificate-link" target="_blank" href="'+_spCertUrl({lab_url:value.lab_url_two,lab:value.lab_two,cert_num:value.cert_num_two})+'" rel="null noopener" >'

                                          + '<span class="certificate-number">'+value.cert_num_two+'</span>'

                                        + '</a>'

                                    + '</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">SHAPE</span>'

                                    + '<span class="meta-info-desc shape-info">'+value.shape_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">CARAT</span>'

                                    + '<span class="meta-info-desc carat-info">'+value.carat_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Cut</span>'

                                    + '<span class="meta-info-desc cut-info">'+value.cut_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Color</span>'

                                    + '<span class="meta-info-desc color-info">'+value.color_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Clarity</span>'

                                    + '<span class="meta-info-desc clarity-info">'+value.clarity_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Polish</span>'

                                    + '<span class="meta-info-desc polish-info">'+value.polish_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Symmetry</span>'

                                    + '<span class="meta-info-desc symmetry-info">'+value.symmetry_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">Fluorescence</span>'

                                    + '<span class="meta-info-desc fluorescence-info">'+value.fluorescence_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">TABLE</span>'

                                    + '<span class="meta-info-desc table-info">'+value.table_two+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">DEPTH</span>'

                                    + '<span class="meta-info-desc depth-info">'+value.depth_two+'%</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">MEASUREMENT</span>'

                                    + '<span class="meta-info-desc measurements-info">'+value.measurement_two+'</span>'

                                + '</p>'

                                + '<p>'

                                    + '<span class="meta__title">L/W RATIO</span>'

                                    + '<span class="meta-info-desc l-w-ratio-info">'+value.lw_ratio_two+'</span>'

                                + '</p>'

                            + '</div>'

                        + '</div>'

                        + '<div class="accordion-header price-match-guarantee" style="display: none;">'

                            + '<h3>DIAMOND PRICE GUARANTEE</h3>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content">'

                            + '<p class="learn--more">Our large inventory of exclusive diamonds is fair priced! Therefore, if you find the same diamond with a matching GIA or IGI certificate, we will honor the price.'

                                + '<span>'

                                  + '<a href="#" data-uw-rm-brl="PR" data-uw-original-href="#"  >Learn more.</a>'

                                + '</span>'

                            + '</p>'

                        + '</div>'

                        + '<div class="accordion-header lifetime-diamond-upgrade">'

                            + '<h3>LIFETIME DIAMOND UPGRADE</h3>'

                            + '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'

                        + '</div>'

                        + '<div class="accordion-content">'

                            + '<p>'+_diamondUpdate+'</p>'

                        + '</div>'

                    + '</div>'

                + '</div>'

            + '</div>';

          

          }

        doloader('hide');

        window.__spDiamondBooted = true; // block any late early-render fill

        $('#mainproduct').empty('').append(productHtml).addClass('sp-hyd').show();

        // (2026-09-24) Platinum settings run on their own ring lead. If the shopper
        // already chose a platinum setting (setting-first flow), re-date "Ships in a
        // ring by" on the platinum lead. Diamond-first shoppers have not picked a
        // metal yet and keep the standard ring date; step 3 shows the exact one.
        if (window.SP_FF && window.SP_FF.chosenSettingLane) {
          window.SP_FF.chosenSettingLane(function (lane) {
            if (lane !== window.SP_FF.RING_PT) return;
            var _ptDate = window.SP_FF.shipByDate('', lane, window.__spDiamondIsNivoda ? 'nivoda' : '');
            $('#mainproduct .product-form_ship-in-ring-timeline b').text(window.SP_FF.format(_ptDate));
          });
        }

        // 360 facade activation - the slide ships as a poster (still.jpg) and
        // the heavy gem360/loupe360 viewer iframe is created only when the
        // shopper taps the facade. Delegated so it works for every rebuilt
        // gallery. Saves ~7 MB + ~19 requests per PDP view for everyone who
        // doesn't engage the 360.
        $(document).on('click', '.sp-360-facade', function(){

          var src = this.getAttribute('data-viewer-src');

          if (!src) return;

          var f = document.createElement('iframe');

          f.setAttribute('scrolling', 'no');

          f.setAttribute('data-uw-rm-iframe', 'un');

          f.src = (src.indexOf('gem360')>-1 && src.indexOf('controls=')===-1) ? (src + (src.indexOf('?')>-1?'&':'?') + 'controls=0') : src;

          f.setAttribute('width', this.clientWidth||this.offsetWidth||360);f.setAttribute('height', this.clientHeight||this.offsetHeight||360);var _fac=this,_slide=this.parentNode;try{_slide.style.position='relative';}catch(e){}f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0;z-index:2;opacity:0;transition:opacity .3s ease;';f.addEventListener('load',function(){requestAnimationFrame(function(){f.style.opacity='1';});setTimeout(function(){try{if(_fac&&_fac.parentNode)_fac.parentNode.removeChild(_fac);}catch(e){}},350);});_slide.appendChild(f);

        });

        var handle = $( "#custom-handle" );

        $( "#slider" ).slider({

            min: 0.20,

            max: 6,

            step: 0.01,

            create: function() {

              handle.html( '<span>'+$( this ).slider( "value" )+' Ct.<span>' );

            },

            slide: function( event, ui ) {

              handle.html( '<span>'+ui.value+' Ct.<span>'  );

              $('.hand_diamond_img').css('background-size', 41 + (ui.value * 5)+'%' );

            }

        });



        // Init Swiper only on mobile

        if (window.innerWidth <= 1023) {

            new Swiper(".product-media-gallery", {

                loop: true,

                pagination: { el: ".swiper-pagination", clickable: true },

            });

            const mobileRange = document.getElementById("mobileRange");

            const rangeValue = document.querySelector(".range-value");



            if (mobileRange) {

                mobileRange.addEventListener("input", function() {

                rangeValue.textContent = this.value + " Ct";



                // TODO: update diamond image scaling here if needed

                let handDiamond = document.querySelector(".hand_diamond_img");

                if (handDiamond) {

                    handDiamond.style.backgroundSize = (20 + this.value * 5) + "%";

                }

                });

            }

        }



        //Sticky add to cart

        var $stickyBar = $(".sticky-button-price-wrapper");

        var $parent = $stickyBar.parent(); // Parent container of sticky bar



        if ($stickyBar.length) {

            /* 2026-06-26: pin the sticky Add-to-Ring bar ONLY when the inline
               button is FULLY out of the viewport (BE-style, no double-up). A
               0-height anchor placed just before the bar gives a stable target
               so the toggle cannot oscillate (anchor never goes fixed). */
            var _bar = $stickyBar[0];
            var _anchor = document.createElement("div");
            _anchor.className = "sp-atc-anchor";
            _anchor.style.cssText = "height:0;margin:0;padding:0;border:0;";
            if (_bar.parentNode) { _bar.parentNode.insertBefore(_anchor, _bar); }
            var _updateSticky = function () {
                var aTop = _anchor.getBoundingClientRect().top;
                var aBot = aTop + (_bar.offsetHeight || 0);
                var inlineVisible = (aBot > 0) && (aTop < window.innerHeight);
                if (inlineVisible) { _bar.classList.remove("sticky-button"); }
                else { _bar.classList.add("sticky-button"); }
            };
            _updateSticky();
            window.addEventListener("scroll", _updateSticky, { passive: true });
            window.addEventListener("resize", _updateSticky);
            [300, 900, 1800].forEach(function (t) { setTimeout(_updateSticky, t); });

        }



      }else{

          doloader('hide');

          $('#noproduct').css('display','flex');

      }

      

    }).catch(function(error){
        // (2026-07-01) was EMPTY -> a failed hydrate (network/5xx/CORS) froze the shopper
        // on the grey skeleton forever. Fail into the recoverable "unavailable" state.
        doloader('hide');
        // Hide any stale/partial product markup behind the card (same as the
        // sp-diamond-skel watchdog path does).
        var _mp = document.getElementById('mainproduct');
        if (_mp) { _mp.style.display = 'none'; }
        // This branch is a fetch/network failure, not a sold/empty API result -
        // swap the card's "no longer available" copy for connection wording.
        // Only retext existing elements; the card markup itself stays untouched.
        var _np = document.getElementById('noproduct');
        if (_np) {
            var _npHead = _np.querySelector('h1, h2, h3, h4');
            if (_npHead) { _npHead.textContent = "We couldn't load this diamond"; }
            var _npBody = _np.querySelector('p');
            if (_npBody) {
                _npBody.textContent = _npHead
                    ? 'Please check your connection and refresh to try again.'
                    : "We couldn't load this diamond. Please check your connection and refresh to try again.";
            }
        }
        $('#noproduct').css('display','flex');
    })

  }

  getData();

}else{

     setTimeout(() => {

      doloader('hide');

      $('#noproduct').css('display','flex');

    }, 1000);

}



//accordians

$(document).on('click','.accordion-header',function(){

  if( $(this).hasClass('active') ){

    $(this).removeClass('active');

    $(this).next('.accordion-content').slideToggle();

  }else{

    $('.accordion-header').removeClass('active');

    $('.accordion-content').slideUp("slow");

    $(this).addClass('active');

    $(this).next('.accordion-content').slideToggle();

  }

});



//accordians

$(document).on('click','.diamond-360',function(){

  $('.diamond-thumbnil').removeClass('active');

  $(this).addClass('active');

  $('.diamondimg').hide();

  $('.diamond-fingure-view').hide();

  $('.diamond-iframe').show().find('iframe').attr('src',$(this).attr('data-frame'));

});

$(document).on('click','.diamond-size-preivew',function(){

  $('.diamond-thumbnil').removeClass('active');

  $(this).addClass('active');

  $('.diamondimg').hide();

  $('.diamond-iframe').hide().find('iframe').attr('src','');

  $('.diamond-fingure-view').show();

  $("#slider").slider('value',parseFloat($(this).attr('data-carat') ));

  var handle = $( "#custom-handle" );

  handle.html( '<span>'+$(this).attr('data-carat')+' Ct.<span>'  );

});

$(document).on('click','.diamond-image',function(){

  $('.diamond-thumbnil').removeClass('active');

  $(this).addClass('active');

  $('.diamond-iframe').hide().find('iframe').attr('src','');

  $('.diamond-fingure-view').hide();

  $('.diamondimg').show();

});



//Create product

$(document).on('click', '#createproduct' , function(e){

  e.preventDefault();

  $(this).parent().addClass('button-active');

  //$(this).text('Wait...');

  //check main product type

  var _selectedRing = $.cookie("_ring");

  if(_selectedRing){

    _ringData = $.parseJSON(_selectedRing);

    var _productType = _ringData.productType

    _productType = (_productType=='Rings') ? 'Ring' : _productType;

    var _btnTxt = 'Add to '+_productType;

  }else{

    var _btnTxt = 'Add to Ring';

    var _productType = 'Ring';

  }

  

  // 2026-05-20: legacy api.stienhardt.com removed. Supabase nivoda-createproduct

  // (v5+) handles both stienhard and nivoda SKUs; verify_jwt=false so no auth.

  var $btn = $(this);

  function isEmptyDiamond(d){ return !d || (Array.isArray(d) && d.length === 0); }

      // 2026-06-23: buy-loose now adds via AJAX /cart/add.js with retry-on-422.
      // On-demand created diamond products can 422 'Cannot find variant' for a few
      // seconds until the storefront index propagates; retry instead of dumping the
      // customer on Shopify's raw error page (old code did a native form .submit()).
      function spLooseAdd($b, attempt){
        attempt = attempt || 0;
        var $f = $('#product_form_8281019023643').first();
        $.ajax({ url: '/cart/add.js', type: 'POST', dataType: 'json', data: $f.serialize() })
          .done(function(){ window.location.href = '/cart'; })
          .fail(function(xhr){
            var desc = (xhr && xhr.responseJSON && xhr.responseJSON.description) || '';
            if (xhr && xhr.status === 422 && /variant/i.test(desc) && attempt < 4){
              setTimeout(function(){ spLooseAdd($b, attempt + 1); }, 1500);
            } else {
              if ($b) $b.parent().removeClass('button-active');
              try { if (window.clarity) clarity('event', 'bld_buy_loose_failed'); } catch(e){}
              alert('This diamond is still being prepared \u2014 please click Buy Loose once more in a few seconds.');
            }
          });
      }

  axios.get(`https://pxixbvvukwwmhmbyzdfu.supabase.co/functions/v1/nivoda-createproduct/${_sku}`).then(response=>{

      var diamondData = response.data.Diamond;

      if(!isEmptyDiamond(diamondData) && diamondData.shopify_res

         && diamondData.shopify_res.product

         && diamondData.shopify_res.product.variants

         && diamondData.shopify_res.product.variants[0]){

        $('#productid').val(diamondData.shopify_id);

        $('#mainvid').val(diamondData.shopify_res.product.variants[0].id);

        spLooseAdd($btn, 0); return;

      } else {

        console.error('createproduct: no usable variant id from either backend', diamondData);

        $btn.parent().removeClass('button-active');

        alert('Sorry, this diamond could not be prepared for checkout. Please try a different stone.');

        return;

      }

      $btn.parent().removeClass('button-active');

    }).catch(error=>{

        $btn.parent().removeClass('button-active');

    })

});



//Set product in cookies

$(document).on('click', '#addtoring' , function(e){

  $(this).parent().addClass('button-active');

  var $atrBtn = $(this);

  /* 2026-07-01: a stone with a null/missing shape threw on .toLowerCase()
     below, and with the spinner cleanup at the bottom commented out the
     spinner ran forever. Guard the shape read + wrap the body so ANY throw
     stops the spinner and tells the shopper. */
  try {

  if (!_diamonmd || !_diamonmd.shape) {

    $atrBtn.parent().removeClass('button-active');

    alert('Something went wrong preparing this diamond. Please refresh and try again.');

    return;

  }

    //Comapre ring + diamond type

    var ___selectedShapes = $.cookie("_selectedShapes");

    if (_diamonmd && _diamonmd.canonical_shape) { _diamonmd.shape = _diamonmd.canonical_shape; }

    _mainShape = _diamonmd.shape;

    /* Moval→Oval remap REMOVED 2026-07-31: settings now carry a native Moval
       Shape option (49 products) + dedicated moval-diamond-engagement-rings
       collection. Moval routes as itself. */

    // 7th Jan 2026

    if (

        _diamonmd.shape.toLowerCase() == 'long cushion') {

        _diamonmd.shape = 'Long Cushion';

    }

    // 10th Jan 2026

    // Edited: Elongated Hexagon now has its own setting variants - normalize to Title Case instead of remapping to Marquise.

    // French Marquise still remaps to Marquise until FM gets its own variants.

    var _shapeLower = _diamonmd.shape.toLowerCase();

    if( _shapeLower == 'french marquise' ){

      _diamonmd.shape = 'Marquise';

    }

    if (_shapeLower == 'dutch marquise') {

      _diamonmd.shape = 'Dutch Marquise';

    }

    if (_shapeLower == 'elongated hexagon') {

      _diamonmd.shape = 'Elongated Hexagon';

    }

    // Antique/Old Mine (2026-07-09): the diamond's canonical shape is "Antique
    // Cuts" but the setting option value is now "Old Mine". Map to the SETTING
    // space here — BEFORE the _activeShape compare below and the settings-catalog
    // filter (?filter.v.option.shape=) further down — otherwise an Old Mine
    // setting is wrongly seen as a shape mismatch (its _ring cookie gets dropped)
    // and the engagement-rings filter looks for "Antique Cuts" and finds 0.
    if (_diamonmd.shape.toLowerCase().indexOf('antique') !== -1) {

      _diamonmd.shape = 'Old Mine';

    }

    if(___selectedShapes){

      var ___selectedShapesData = $.parseJSON(___selectedShapes);

      if( ___selectedShapesData._activeShape != _diamonmd.shape ){

        $.removeCookie('_ring', { path: '/' });

      }

    }

  //_diamonmd.shape = _mainShape;

  var sku = $(this).attr('data-sku');

  var _diamondFor = $(this).attr('data-product');

   if(_diamonmd.shape.indexOf('Antique') !== -1){

      _diamonmd.shape = 'Old Mine';

   }

  var _dData = {

    "sku" : _diamonmd.sku,

    "shape" : _mainShape,

    "cover_pic" : _diamonmd.cover_pic,

    "type" : _diamonmd.type,

  };

  $.removeCookie("_diamonmd");

  $.cookie("_diamonmd", JSON.stringify(_dData), { expires: 7 ,  path: '/' });



  //check selected diamond

  var _selectedRing = $.cookie("_ring");

  if(_selectedRing){

    _ringData = $.parseJSON(_selectedRing);

    var _ProductType = _ringData.productType;

    _ProductType = (_ProductType == '') ? 'Ring' : _ProductType;

    if(_ProductType == 'Ring' || _ProductType == 'Rings'){

      var _linkStr = '';

    }else if(_ProductType== 'Earrings' || _ProductType== 'Earring'){

      var _linkStr = 'earring-';

    }else if(_ProductType== 'Necklace' || _ProductType== 'Necklaces'){

      var _linkStr = 'necklace-';

    }

    if(_diamondFor=='' && ( _ProductType== 'Earrings' || _ProductType== 'Earring' ) ){

      $.removeCookie('_ring', { path: '/' });

      //window.location.href = _ringData.handle;

        window.location.href = '/collections/engagement-rings?filter.v.option.shape='+_diamonmd.shape;
      return;

    }

    

    var newhref = _ringData.handle+'?variant='+_ringData.vid+'&view=final-ring&diamond='+_diamonmd.sku;

    window.location.href = newhref; 

  }else{

    if(_diamondFor=='Earring'){

      window.location.href = '/collections/create-your-own-earrings?filter.v.option.shape='+_diamonmd.shape;

    }else{

      window.location.href = '/collections/engagement-rings?filter.v.option.shape='+_diamonmd.shape;

    }

    

  }

  /* Success paths above navigate away - the spinner intentionally stays on
     until the next page paints. Failure cleanup lives in the catch below
     (replaces the old commented-out removeClass that never ran). */

  } catch (err) {

    $atrBtn.parent().removeClass('button-active');

    console.error('addtoring: failed to prepare diamond', err);

    alert('Something went wrong preparing this diamond. Please refresh and try again.');

  }

});



});



